export default {
  acceptTermsRequired: 'ದಯವಿಟ್ಟು terms and conditions ಒಪ್ಪಿಕೊಳ್ಳಿ',
  accountNumber: 'A/C Number',
  acknowledgedText: 'ಒಪ್ಪಿಕೊಂಡಿದೆ',
  acknowledgeText: 'ಒಪ್ಪಿಕೊಳ್ಳಿ',
  active: 'ಸಕ್ರಿಯ',
  activeBookings: 'ಸಕ್ರಿಯ ಬುಕಿಂಗ್‌ಗಳು',
  activeBucketsText: 'ಸಕ್ರಿಯ ಬಕೆಟ್‌ಗಳು',
  activeToday: 'ಇಂದು ಸಕ್ರಿಯ',
  adminRole: 'ಅಡ್ಮಿನ್ — ವ್ಯವಸ್ಥಾಪಕ ನಿರ್ದೇಶಕ',
  advance: 'ಮುಂಗಡ',
  advancePaid: 'ಮುಂಗಡ ಪಾವತಿ',
  advancePaidLabel: 'ಮುಂಗಡ',
  agreement: 'ನಿಯಮಗಳು & ಒಪ್ಪಂದ',
  agreeTermsCheckbox: 'ನಾನು ಎಲ್ಲಾ ನಿಯಮಗಳು & ಷರತ್ತುಗಳನ್ನು ಓದಿ ಒಪ್ಪಿಕೊಂಡಿದ್ದೇನೆ',
  alertLog: 'ಎಚ್ಚರಿಕೆ ಲಾಗ್',
  alerts: 'ಎಚ್ಚರಿಕೆಗಳು',
  alertText: 'ಎಚ್ಚರಿಕೆ',
  allAlerts: 'ಎಲ್ಲಾ ಎಚ್ಚರಿಕೆಗಳು',
  allLoaded: 'ಎಲ್ಲಾ ಲೋಡ್',
  allMachinesOk: 'ಎಲ್ಲಾ ಯಂತ್ರಗಳು ಸರಿಯಾಗಿ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತಿವೆ.',
  allowedText: 'ಅನುಮತಿಸಲಾಗಿದೆ',
  allStats: 'ಸಂಪೂರ್ಣ ಅಂಕಿಅಂಶಗಳು',
  amount: 'ಮೊತ್ತ',
  apiHealthTitle: 'API Health',
  apiSloAlertsTitle: 'API SLO Alerts',
  appName: 'ಡೆವಲಪ್‌ಮೆಂಟ್ ಎಕ್ಸ್‌ಪ್ರೆಸ್',
  approvals: 'ಅನುಮೋದನೆಗಳು',
  approveAndDispatch: 'ಅನುಮೋದಿಸಿ ಯಂತ್ರ ಕಳುಹಿಸಿ',
  approved: 'ಅನುಮೋದಿಸಲಾಗಿದೆ',
  assignedOperator: 'ನಿಯೋಜಿತ ಆಪರೇಟರ್',
  attemptsLabel: 'ಪ್ರಯತ್ನಗಳು',
  attendance: 'ಹಾಜರಾತಿ',
  auditLogs: 'ಆಡಿಟ್ ಲಾಗ್‌ಗಳು',
  available: 'ಲಭ್ಯ',
  availableMachinery: 'ಲಭ್ಯ ಮೆಷಿನರಿ',
  availableNow: 'ಈಗ ಲಭ್ಯ',
  avgRating: 'ಸರಾಸರಿ ರೇಟಿಂಗ್',
  awaitingClientFeedback: 'ಗ್ರಾಹಕ ಪ್ರತಿಕ್ರಿಯೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ',
  awaitingDispatch: 'ಡಿಸ್ಪ್ಯಾಚ್‌ಗಾಗಿ ಕಾಯುತ್ತಿದೆ',
  back: 'ಹಿಂದೆ ಹೋಗಿ',
  backToLogin: 'ಲಾಗಿನ್‌ಗೆ ಹಿಂತಿರುಗಿ',
  bank: 'ಬ್ಯಾಂಕ್',
  bankDetailsTitle: 'ಬ್ಯಾಂಕ್ ವಿವರಗಳು',
  baseAmount: 'ಮೂಲ ಮೊತ್ತ',
  billingWallet: 'ವಾಲೆಟ್ & ಬಿಲ್ಲಿಂಗ್',
  blacklistWarning: '⛔ ಬ್ಲ್ಯಾಕ್‌ಲಿಸ್ಟ್ ಎಚ್ಚರಿಕೆ',
  blockedRateText: 'ಬ್ಲಾಕ್ ದರ',
  blockedText: 'ಬ್ಲಾಕ್',
  bookingConfirm: 'ಬುಕಿಂಗ್ ದೃಢೀಕರಿಸಿ',
  bookingCostCalculator: 'ಬುಕಿಂಗ್ & ವೆಚ್ಚ ಕ್ಯಾಲ್ಕುಲೇಟರ್',
  bookingFailedGeneric: 'ಬುಕಿಂಗ್ ವಿಫಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  bookingHistory: 'ಬುಕಿಂಗ್ ಇತಿಹಾಸ',
  bookingReportTitle: 'ಬುಕಿಂಗ್ ವರದಿ',
  bookingScheduleSummary: 'ದಿನ & ತಿಂಗಳ ವಾರಿ ಬುಕಿಂಗ್ ಷೆಡ್ಯೂಲ್',
  bookingsCount: '{count} ಬುಕಿಂಗ್‌ಗಳು',
  bookingSelectMachineFirst: 'ಮುಂದುವರಿಯಲು ಫ್ಲೀಟ್‌ನಿಂದ ಯಂತ್ರ ಆಯ್ಕೆ ಮಾಡಿ.',
  bookingsScheduleHint: 'ಗ್ರಾಹಕರು ಬುಕ್ ಮಾಡಿದ ನಂತರ ದಿನದ ಷೆಡ್ಯೂಲ್ ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.',
  bookingStepChoose: 'ಯಂತ್ರ ಆಯ್ಕೆ ಮಾಡಿ',
  bookingStepConfirm: 'ದೃಢೀಕರಿಸಿ ಪಾವತಿಸಿ',
  bookingStepCost: 'ವೆಚ್ಚ & ದಿನಾಂಕಗಳು',
  bookingType: 'ಬುಕಿಂಗ್ ವಿಧ ಆಯ್ಕೆ ಮಾಡಿ',
  bookingTypeLabel: 'ಬುಕಿಂಗ್ ಪ್ರಕಾರ',
  bookingTypeText: 'ಬುಕಿಂಗ್ ವಿಧ',
  bookMachine: 'ಯಂತ್ರ ಬುಕ್ ಮಾಡಿ',
  bookMachineAction: 'ಯಂತ್ರ ಬುಕ್ ಮಾಡಿ',
  bookNow: 'ಈಗ ಬುಕ್ ಮಾಡಿ',
  burstText: 'BURST',
  busy: 'ಬ್ಯುಸಿ',
  callNow: 'ಈಗ ಕರೆ ಮಾಡಿ',
  cancel: 'ರದ್ದು ಮಾಡಿ',
  cancelAction: 'ರದ್ದು ಮಾಡಿ',
  cancelBooking: 'ಬುಕಿಂಗ್ ರದ್ದು ಮಾಡಿ',
  cancelBookingPrompt: 'ಬುಕಿಂಗ್ ರದ್ದು ಮಾಡಬೇಕೇ?',
  cancelPolicy: 'ರದ್ದು ನೀತಿ',
  cancelText: 'ರದ್ದು',
  cancelWarning: 'ನೀವು ರದ್ದು ಮಾಡಲು ಬಯಸುತ್ತೀರಾ?',
  changeLanguage: 'ಭಾಷೆ ಬದಲಿಸಿ',
  changeMachine: 'ಯಂತ್ರ ಬದಲಿಸಿ',
  changeMobileNumber: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಬದಲಿಸಿ',
  chipAction: 'ಕ್ರಿಯೆ',
  chipActor: 'ನಟ',
  chipEntity: 'entity',
  chipFrom: 'ನಿಂದ',
  chipMeta: 'meta',
  chipRole: 'ಪಾತ್ರ',
  chipTo: 'ವರೆಗೆ',
  clearAll: 'ಎಲ್ಲಾ ಕ್ಲಿಯರ್ ಮಾಡಿ',
  client: 'ಗ್ರಾಹಕ',
  clientFeedbackLabel: 'ಗ್ರಾಹಕ ಪ್ರತಿಕ್ರಿಯೆ',
  clientPortal: 'ಗ್ರಾಹಕರ ಪೋರ್ಟಲ್',
  clientRatingsTitle: 'ಗ್ರಾಹಕ ರೇಟಿಂಗ್‌ಗಳು & ಸಲಹೆಗಳು',
  clientRole: 'ಗ್ರಾಹಕ (ಗುತ್ತಿಗೆದಾರ)',
  clients: 'ಗ್ರಾಹಕರು',
  commission: 'ಕಮಿಷನ್',
  commission15: 'ಕಮಿಷನ್ 15%',
  commissionPaid: 'ಕಮಿಷನ್ ಪಾವತಿಸಲಾಗಿದೆ',
  commissionRate: 'ಒಟ್ಟು ಬಿಲ್ಲಿಂಗ್‌ನ 15%',
  company: 'ಕಂಪನಿ',
  companyDetailsTitle: 'ಕಂಪನಿ ವಿವರಗಳು',
  completeBookings: 'ಪೂರ್ಣ ಬುಕಿಂಗ್‌ಗಳು',
  completedBookings: 'ಪೂರ್ಣ ಬುಕಿಂಗ್‌ಗಳು',
  condition: 'ಸ್ಥಿತಿ',
  confirm: 'ದೃಢೀಕರಿಸಿ',
  confirmBooking: 'ಬುಕಿಂಗ್ ದೃಢೀಕರಿಸಿ',
  confirmBookingAction: 'ಬುಕಿಂಗ್ ದೃಢೀಕರಿಸಿ',
  confirmCancel: 'ರದ್ದು ದೃಢೀಕರಿಸಿ',
  confirmPassword: 'ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ',
  confirmRetry: 'ಮರು ಪ್ರಯತ್ನ ದೃಢೀಕರಿಸಿ',
  contactCompany: 'Development Express ಸಂಪರ್ಕಿಸಿ',
  costCalculator: 'ವೆಚ್ಚ ಕ್ಯಾಲ್ಕುಲೇಟರ್',
  crawlerNoRto: 'Crawler (RTO ಇಲ್ಲ)',
  currentlyDeployed: 'ಪ್ರಸ್ತುತ ನಿಯೋಜಿತ',
  customAmount: 'ಕಸ್ಟಮ್ ಮೊತ್ತ (ಕನಿಷ್ಠ ₹5,000)',
  cycles: "ಚಕ್ರಗಳು",
  dailyWorkReport: 'ದೈನಂದಿನ ಕೆಲಸ ವರದಿ',
  dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
  date: 'ದಿನಾಂಕ',
  dayMachinesLabel: 'ಯಂತ್ರಗಳು',
  days: 'ದಿನಗಳು',
  daysUnit: 'ದಿನ',
  directContactBlacklist: 'ನೇರ ಸಂಪರ್ಕ = ಬ್ಲಾಕ್‌ಲಿಸ್ಟ್',
  directContactProhibited: 'ನೇರ ಸಂಪರ್ಕ ಕಟ್ಟುನಿಟ್ಟಾಗಿ ನಿಷೇಧಿಸಲಾಗಿದೆ',
  directContactProhibitedText: 'ನೇರ ಸಂಪರ್ಕ ಕಟ್ಟುನಿಟ್ಟಾಗಿ ನಿಷೇಧಿಸಲಾಗಿದೆ',
  dispatched: 'ಕಳುಹಿಸಲಾಗಿದೆ',
  dlqMonitor: 'DLQ ಮಾನಿಟರ್',
  docChassisPlate: 'Chassis / Serial Plate Photo (RTO RC ಇಲ್ಲ)',
  docEquipmentPhoto: 'Full Machine Photo (side view)',
  docIdentity: 'PAN Card / Aadhaar',
  docInsurance: 'Insurance Certificate',
  docInsuranceOptional: 'Insurance / Equipment Cover (if available)',
  docMachineInvoice: 'Machine Purchase / Invoice (dealer bill)',
  docPollution: 'Pollution Certificate (PUC)',
  docRcBook: 'RC Book (RTO Registration Certificate)',
  documents: 'ದಾಖಲೆಗಳು ಅಪ್‌ಲೋಡ್',
  documentUploadTitle: 'ದಾಖಲೆಗಳು ಅಪ್‌ಲೋಡ್',
  download: 'ಡೌನ್‌ಲೋಡ್',
  drawerMenu: 'ಮೆನು',
  earnings: 'ಆದಾಯ',
  email: 'ಇಮೇಲ್ ಬೆಂಬಲ',
  emailAddress: 'ಇಮೇಲ್ ವಿಳಾಸ',
  emailAddressLabel: 'ಇಮೇಲ್ ವಿಳಾಸ',
  expandBookingHint: 'ಪೂರ್ಣ ಬುಕಿಂಗ್, ರದ್ದು ಮತ್ತು ಆಪರೇಟರ್ ರೇಟಿಂಗ್‌ಗಾಗಿ ಕೆಳಗೆ ತಿಂಗಳು/ದಿನ ವಿಭಾಗ ವಿಸ್ತರಿಸಿ.',
  experience: 'ಅನುಭವ',
  exportCsv: 'CSV ಎಕ್ಸ್‌ಪೋರ್ಟ್',
  failedText: 'ವಿಫಲ',
  feedbackAfterDispatch: 'ಯಂತ್ರ ಡಿಸ್ಪ್ಯಾಚ್ ನಂತರ ಆಪರೇಟರ್ ರೇಟಿಂಗ್ ಲಭ್ಯ.',
  feedbackStatusAfterDispatch: 'ಡಿಸ್ಪ್ಯಾಚ್ ನಂತರ',
  feedbackStatusRateNow: 'ಆಪರೇಟರ್ ರೇಟ್ ಮಾಡಿ ↓',
  filterAll: 'ಎಲ್ಲಾ',
  filterCredit: 'ಕ್ರೆಡಿಟ್',
  filterDebit: 'ಡೆಬಿಟ್',
  filterCompleted: 'ಪೂರ್ಣ',
  filterCancelled: 'ಮುಚ್ಚಲಾಗಿದೆ',
  filterPending: 'ಬಾಕಿ',
  filterDisputed: 'ವಿವಾದ',
  forgotPasswordChooseMethod: 'ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಲು ಇಮೇಲ್ ಲಿಂಕ್ ಅಥವಾ SMS OTP ಆಯ್ಕೆಮಾಡಿ.',
  forgotPasswordEmailDevHint: 'Local dev: API server ಟರ್ಮಿನಲ್ ತೆರೆದು “Password reset link (development)” URL ನಕಲಿಸಿ.',
  forgotPasswordEmailHint: 'ನೋಂದಾಯಿತ ಅಡ್ಮಿನ್ ಇಮೇಲ್ ವಿಳಾಸ ನಮೂದಿಸಿ.',
  forgotPasswordFailed: 'ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ಕಳುಹಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  forgotPasswordIntro: 'ನೋಂದಾಯಿತ ಇಮೇಲ್ ವಿಳಾಸಕ್ಕೆ ಸುರಕ್ಷಿತ ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ಕಳುಹಿಸುತ್ತೇವೆ.',
  forgotPasswordInvalidEmail: 'ಮಾನ್ಯ ಇಮೇಲ್ ವಿಳಾಸ ನಮೂದಿಸಿ.',
  forgotPasswordInvalidOtp: 'SMS ನಿಂದ 6 ಅಂಕಿಯ OTP ನಮೂದಿಸಿ.',
  forgotPasswordInvalidPhone: 'ಮಾನ್ಯ 10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.',
  forgotPasswordLink: 'ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿದ್ದೀರಾ?',
  forgotPasswordOtpSentTo: 'OTP ಕಳುಹಿಸಲಾಗಿದೆ:',
  forgotPasswordPhoneHint: 'ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ. ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ನಿಮ್ಮ ಖಾತೆಯ ಇಮೇಲ್‌ಗೆ ಹೋಗುತ್ತದೆ.',
  forgotPasswordSending: 'ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...',
  forgotPasswordSendingOtp: 'OTP ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...',
  forgotPasswordSendOtp: 'OTP ಕಳುಹಿಸಿ',
  forgotPasswordSmsDevHint: 'Productionನಲ್ಲಿ SMS ಇನ್ನೂ ಸೆಟ್ ಆಗಿಲ್ಲ — developmentನಲ್ಲಿ OTP ಕೋಡ್‌ಗಾಗಿ server logs ನೋಡಿ.',
  forgotPasswordSmsFailed: 'OTP ಕಳುಹಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  forgotPasswordSmsHint: 'ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ. 6 ಅಂಕಿಯ OTP SMS ಮೂಲಕ ಕಳುಹಿಸಲಾಗುತ್ತದೆ.',
  forgotPasswordSmsSuccess: 'ಖಾತೆ ಇದ್ದರೆ, ನೋಂದಾಯಿತ ಮೊಬೈಲ್‌ಗೆ OTP ಕಳುಹಿಸಲಾಗಿದೆ.',
  forgotPasswordSubmit: 'ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ಕಳುಹಿಸಿ',
  forgotPasswordSuccess: 'ಖಾತೆ ಇದ್ದರೆ, ನೋಂದಾಯಿತ ಇಮೇಲ್‌ಗೆ ಮರುಹೊಂದಿಸುವ ಸೂಚನೆಗಳು ಕಳುಹಿಸಲಾಗಿದೆ.',
  forgotPasswordTitle: 'ನಿಮ್ಮ ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಿ',
  formLabel: 'ಫಾರ್ಮ್',
  fuel: 'ಇಂಧನ',
  fuelColon: 'ಇಂಧನ:',
  fuelHistoryTitle: 'ಇಂಧನ ಇತಿಹಾಸ',
  fuelLevel: 'ಇಂಧನ ಮಟ್ಟ',
  fuelLevelUpdate: 'ಇಂಧನ ಮಟ್ಟ ಅಪ್‌ಡೇಟ್',
  fuelNotePlaceholder: 'ಟಿಪ್ಪಣಿ: ತುಂಬಿದ / ಬಳಸಿದ ಇಂಧನ...',
  fullName: 'ಪೂರ್ಣ ಹೆಸರು',
  goBook: '→ ಯಂತ್ರ ಬುಕ್ ಮಾಡಿ',
  gpsLiveLabel: '🟢 GPS ಲೈವ್',
  grandTotal: 'ಒಟ್ಟು ಮೊತ್ತ',
  grandTotalText: 'ಒಟ್ಟು ಮೊತ್ತ',
  gross: 'ಒಟ್ಟು',
  grossBilling: 'ಒಟ್ಟು ಬಿಲ್ಲಿಂಗ್',
  gst18: 'GST (18%)',
  gstin: 'GSTIN',
  gstInvoice: 'GST ಇನ್‌ವಾಯ್ಸ್',
  gstInvoices: 'GST ಇನ್‌ವಾಯ್ಸ್‌ಗಳು',
  hide: 'ಮರೆಮಾಡಿ',
  highTrend: 'HIGH Trend',
  hitsText: 'hits',
  hmrHrs: 'ಗಂ',
  hmrToday: 'ಇಂದಿನ HMR',
  hmrTotal: 'ಒಟ್ಟು HMR',
  home: 'ಹೋಮ್',
  hours: 'ಗಂಟೆಗಳು',
  hrsUnit: 'ಗಂಟೆ',
  idle: 'ನಿಷ್ಕ್ರಿಯ',
  ifsc: 'IFSC',
  ignition: 'ಇಗ್ನಿಷನ್',
  importantInfo: 'ಯಂತ್ರ ಮಾಲೀಕರಿಗೆ ಮುಖ್ಯ ಮಾಹಿತಿ',
  instantCost: 'ತಕ್ಷಣದ ವೆಚ್ಚ ಕ್ಯಾಲ್ಕುಲೇಟರ್',
  invoiceNotAvailableCancelled: 'ಇನ್‌ವಾಯ್ಸ್ ಲಭ್ಯವಿಲ್ಲ (ರದ್ದು)',
  iot: 'IoT & GPS',
  issueReportedSuccess: 'ಸಮಸ್ಯೆ ಯಶಸ್ವಿಯಾಗಿ ವರದಿ ಮಾಡಲಾಗಿದೆ!',
  issueReportTitle: 'ಸಮಸ್ಯೆ ವರದಿ',
  issues: 'ಸಮಸ್ಯೆಗಳು',
  joinUsAction: 'Join Us — ಉಚಿತ ನೋಂದಣಿ',
  joinUsBanner: 'ಮೆಷಿನರಿ ಬಾಡಿಗೆ ಬೇಕೇ?',
  joinUsHint: 'ಹೊಸ ಗ್ರಾಹಕ? JCB, excavator, crane ಬುಕ್ ಮಾಡಲು ಉಚಿತ ನೋಂದಣಿ.',
  landingCtaApp: 'Development Express ಅನ್ವೇಷಿಸಿ',
  landingFeatBook: 'ನಿಮಿಷಗಳಲ್ಲಿ ಬುಕಿಂಗ್',
  landingFeatBookDesc: 'JCB, excavators, cranes — live availability & instant booking.',
  landingFeatPay: 'Wallet-only payments',
  landingFeatPayDesc: 'ಪಾರದರ್ಶಕ ಬಿಲ್ಲಿಂಗ್, GST invoices, ನಗದು ಗೊಂದಲ ಇಲ್ಲ.',
  landingFeatTrack: 'Live GPS tracking',
  landingFeatTrackDesc: 'ಬಾಡಿಗೆ ಪ್ರತಿ ಗಂಟೆ ನಿಮ್ಮ ಯಂತ್ರ ಎಲ್ಲಿದೆ ಎಂದು ತಿಳಿಯಿರಿ.',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'ಮಹಾರಾಷ್ಟ್ರ ಮೆಷಿನರಿ ಬಾಡಿಗೆ — ಹೊಸ ರೀತಿ.',
  landingSocialProof: 'ಮಹಾರಾಷ್ಟ್ರದ ಬಿಲ್ಡರ್‌ಗಳು, ಕಾಂಟ್ರಾಕ್ಟರ್‌ಗಳು & ಫ್ಲೀಟ್ ಮಾಲೀಕರು.',
  landingStatMachines: 'ಯಂತ್ರಗಳು',
  landingStatRating: 'ರೇಟಿಂಗ್',
  landingTrustLine: 'Wallet-only · GST compliant · Secured operations',
  lastRefreshed: 'ಕೊನೆಯ ರಿಫ್ರೆಶ್',
  live: 'ಲೈವ್',
  liveBookAvail: 'ಬುಕಿಂಗ್ ನಂತರ ಲೈವ್ ಫೀಡ್ ಲಭ್ಯ',
  liveCamera: '360° ಲೈವ್ ಕ್ಯಾಮೆರಾ — ಬುಕಿಂಗ್ ನಂತರ',
  liveMachineLocation: 'ಲೈವ್ ಯಂತ್ರ ಸ್ಥಾನ',
  liveText: 'ಲೈವ್',
  liveTracking: 'ಲೈವ್ ಟ್ರ್ಯಾಕಿಂಗ್',
  loadedBookings: 'ಲೋಡ್ ಬುಕಿಂಗ್‌ಗಳು',
  loadedDlqItems: 'ಲೋಡ್ DLQ ಅಂಶಗಳು',
  loadedFuelLogs: 'ಲೋಡ್ ಇಂಧನ ಲಾಗ್‌ಗಳು',
  loadedOwnerBookings: '{count} ಮಾಲೀಕ ಬುಕಿಂಗ್ ಲೋಡ್{suffix}',
  loading: 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  loadingDashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್ ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  loadMoreAlerts: 'ಹೆಚ್ಚು ಎಚ್ಚರಿಕೆಗಳು ಲೋಡ್ ಮಾಡಿ',
  loadMoreAttendance: 'ಹೆಚ್ಚು ಹಾಜರಾತಿ ಲೋಡ್ ಮಾಡಿ',
  loadMoreBookings: 'ಹೆಚ್ಚು ಬುಕಿಂಗ್‌ಗಳು ಲೋಡ್ ಮಾಡಿ',
  loadMoreDlq: 'ಹೆಚ್ಚು DLQ ಲೋಡ್ ಮಾಡಿ',
  loadMoreFuelLogs: 'ಹೆಚ್ಚು ಇಂಧನ ಲಾಗ್‌ಗಳು ಲೋಡ್ ಮಾಡಿ',
  loadMoreLogs: 'ಹೆಚ್ಚು ಲಾಗ್‌ಗಳು ಲೋಡ್ ಮಾಡಿ',
  loadMoreMachines: 'ಹೆಚ್ಚು ಯಂತ್ರಗಳು ಲೋಡ್ ಮಾಡಿ',
  loadMoreTransactions: 'ಹೆಚ್ಚು ವಹಿವಾಟುಗಳು ಲೋಡ್ ಮಾಡಿ',
  loadMoreUsers: 'ಹೆಚ್ಚು ಬಳಕೆದಾರರು ಲೋಡ್ ಮಾಡಿ',
  location: 'ಸ್ಥಳ',
  lockConfirm: '🔒 ಲಾಕ್ ದೃಢೀಕರಿಸಿ',
  locked: 'ಲಾಕ್',
  lockMachine: 'ಯಂತ್ರ ಲಾಕ್ ಮಾಡಿ',
  lockWarning: 'Teltonika GPS ಮೂಲಕ ಯಂತ್ರದ ಇಗ್ನಿಷನ್ ದೂರದಿಂದ ನಿಷ್ಕ್ರಿಯಗೊಳಿಸಲಾಗುತ್ತದೆ.',
  loginAs: 'ಲಾಗಿನ್ ಆಗುತ್ತಿದ್ದಾರೆ',
  loginChangeRole: 'ಪಾತ್ರ ಬದಲಿಸಿ',
  loginClientPortalSubtitle: 'ನಿರ್ಮಾಣ ಮೆಷಿನರಿ ಬುಕ್ ಮಾಡಲು ಸೈನ್ ಇನ್',
  loginEmailHint: 'ಅಡ್ಮಿನ್ ಲಾಗಿನ್‌ಗೆ ನೋಂದಾಯಿತ ಇಮೇಲ್ ಬಳಸಿ.',
  loginFailedGeneric: 'ಲಾಗಿನ್ ವಿಫಲ — ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
  loginIAmQuestion: 'ನಾನು ಯಾರು…?',
  loginModeOtp: 'OTP ಲಾಗಿನ್',
  loginModePassword: 'ಪಾಸ್‌ವರ್ಡ್',
  loginNewHereRegister: 'ಹೊಸರಾ? ನೋಂದಣಿ',
  loginOtpDevHint: 'Development: SMS ಇಲ್ಲದಿದ್ದರೆ API server log ನಲ್ಲಿ OTP ನೋಡಿ.',
  loginOtpHint: 'ನೋಂದಾಯಿತ ಮೊಬೈಲ್‌ಗೆ 6 ಅಂಕಿಯ OTP ಕಳುಹಿಸಲಾಗುತ್ತದೆ.',
  loginOtpSentTo: 'OTP ಕಳುಹಿಸಲಾಗಿದೆ:',
  loginOwnerPortalSubtitle: 'ಫ್ಲೀಟ್ ಮತ್ತು ನೋಂದಣಿ ನಿರ್ವಹಿಸಲು ಸೈನ್ ಇನ್',
  loginPhoneHint: 'ಗ್ರಾಹಕ, ಮಾಲೀಕ ಮತ್ತು ಆಪರೇಟರ್ ಲಾಗಿನ್‌ಗೆ ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ಬಳಸಿ.',
  loginPickRoleHint: 'ನೋಂದಾಯಿತ? ಪಾತ್ರ ಆಯ್ಕೆಮಾಡಿ. ಹೊಸವರಾ? ಕೆಳಗೆ Join Us.',
  loginPortalAdminSubtitle: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ನಿಯಂತ್ರಣ ಮತ್ತು ಅನುಮೋದನೆ',
  loginPortalAdminTitle: 'ಅಡ್ಮಿನ್ ಪೋರ್ಟಲ್',
  loginPortalClientSubtitle: 'ನಿರ್ಮಾಣ ಮೆಷಿನರಿ ಬುಕ್ ಮಾಡಲು ಸೈನ್ ಇನ್',
  loginPortalClientTitle: 'ಗ್ರಾಹಕ ಪೋರ್ಟಲ್',
  loginPortalOperatorSubtitle: 'ನಿಯೋಜಿತ ಯಂತ್ರಗಳಿಗೆ ಸೈನ್ ಇನ್',
  loginPortalOperatorTitle: 'ಆಪರೇಟರ್ ಪೋರ್ಟಲ್',
  loginPortalOwnerSubtitle: 'ಫ್ಲೀಟ್ ಮತ್ತು ನೋಂದಣಿ ನಿರ್ವಹಿಸಲು ಸೈನ್ ಇನ್',
  loginPortalOwnerTitle: 'ಮಾಲೀಕ ಪೋರ್ಟಲ್',
  loginRoleAdminDesc: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ನಿಯಂತ್ರಣ, ಅನುಮೋದನೆಗಳು',
  loginRoleClientDesc: 'ನಿರ್ಮಾಣ ಯೋಜನೆಗಳಿಗೆ ಮೆಷಿನರಿ ಬುಕ್ ಮಾಡಿ',
  loginRoleClientShort: 'ಗ್ರಾಹಕ',
  loginRoleOperatorDesc: 'ನಿಯೋಜಿತ ಯಂತ್ರಗಳು ಮತ್ತು ದೈನಂದಿನ ಲಾಗ್‌ಗಳು',
  loginRoleOwnerDesc: 'ಫ್ಲೀಟ್, ಆದಾಯ ಮತ್ತು ಲಭ್ಯತೆ ನಿರ್ವಹಿಸಿ',
  loginRoleOwnerShort: 'ಮಾಲೀಕ',
  loginSendingOtp: 'OTP ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ...',
  loginSendOtp: 'OTP ಕಳುಹಿಸಿ',
  loginSignInShort: 'ಸೈನ್ ಇನ್',
  loginTabOtp: 'OTP',
  loginTabPassword: 'ಪಾಸ್‌ವರ್ಡ್',
  loginVerifyingOtp: 'Verify ಆಗುತ್ತಿದೆ...',
  loginVerifyOtp: 'Verify & Sign In',
  logout: 'ಲಾಗ್ ಔಟ್',
  sessionRevokedAlert: 'ನೀವು ಮತ್ತೊಂದು ಸಾಧನದಲ್ಲಿ ಲಾಗಿನ್ ಆಗಿದ್ದೀರಿ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಲಾಗಿನ್ ಮಾಡಿ.',
  machine: 'ಯಂತ್ರ',
  machineDefaultLabel: 'ಯಂತ್ರ',
  machineDetails: 'ಯಂತ್ರ & ಆಪರೇಟರ್ ವಿವರಗಳು',
  machineDetailsTitle: 'ಯಂತ್ರ ವಿವರಗಳು',
  machineDispatchedAt: 'ಯಂತ್ರ ಕಳುಹಿಸಲಾಗಿದೆ — {when}',
  machineHours: 'ಯಂತ್ರ ಗಂಟೆಗಳು',
  machineIdLabel: 'ಯಂತ್ರ ID',
  machineInfo: 'ಯಂತ್ರ ಮಾಹಿತಿ',
  machineLabel: 'ಯಂತ್ರ',
  machineLog: 'ಯಂತ್ರ ಲಾಗ್',
  machineReg: 'ಯಂತ್ರ ನೋಂದಣಿ ಫಾರ್ಮ್',
  machineRegistrationSubmitted: 'ಯಂತ್ರ ನೋಂದಣಿ ಸಲ್ಲಿಸಲಾಗಿದೆ! DE ತಂಡ 24 ಗಂಟೆಗಳಲ್ಲಿ ಪರಿಶೀಲಿಸುತ್ತದೆ.',
  machineRegistrationTitle: 'ಯಂತ್ರ ನೋಂದಣಿ',
  machines: 'ಯಂತ್ರಗಳು',
  machineStatus: 'ಯಂತ್ರ ಸ್ಥಿತಿ',
  machineStatusTitle: 'ಯಂತ್ರ ಸ್ಥಿತಿ',
  marketingBackHome: 'ವೆಬ್‌ಸೈಟ್‌ಗೆ ಹಿಂತಿರುಗಿ',
  marketingBadge: 'LIVE OPERATIONS · KARAD, SATARA',
  marketingBuiltFor: 'ನಿಖರತೆ, ಅನುಪಾಲನೆ ಮತ್ತು ವೇಗ ಬೇಕಾದ ಭಾರತೀಯ ನಿರ್ಮಾಣ ತಂಡಗಳಿಗೆ.',
  marketingCtaBook: 'ಯಂತ್ರ ಬುಕ್ ಮಾಡಿ',
  marketingCtaLogin: 'Development Express ತೆರೆಯಿರಿ — Login',
  marketingCtaWhatsApp: 'WhatsApp ಮಾಡಿ',
  marketingFooterRights: '2026 Development Express · Karad, Satara · All rights reserved',
  marketingHeadline: 'ಮಹಾರಾಷ್ಟ್ರದ leading machinery rental platform',
  marketingLead: 'Real-time GPS tracking, digital wallet payments, and automated operations for construction machinery. Serving Maharashtra since 2011.',
  marketingNavContact: 'ಸಂಪರ್ಕ',
  marketingNavLogin: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಲಾಗಿನ್ →',
  marketingNavServices: 'ಸೇವೆಗಳು',
  marketingNavTech: 'Technology',
  marketingServicesTitle: 'ನಾವು ಏನು ನೀಡುತ್ತೇವೆ',
  marketingStatDigital: 'Digital payments',
  marketingStatFleet: 'Live machines',
  marketingStatYears: 'ವರ್ಷಗಳ ಅನುಭವ',
  marketingSvcOps: 'Full operations stack',
  marketingSvcOpsSub: 'Owner, operator, and client — one platform.',
  marketingSvcPay: 'Wallet-only settlements',
  marketingSvcPaySub: 'GST-ready invoicing — no cash on site.',
  marketingSvcTrack: 'GPS & live status',
  marketingSvcTrackSub: 'Teltonika-linked fleet visibility for every booking.',
  marketingTechLead: 'Development Express ties bookings, compliance, and field telemetry into a single hardened workflow — from first enquiry to final invoice.',
  md: 'MD',
  mediumTrend: 'MEDIUM Trend',
  minAdvanceRequired: 'ಕನಿಷ್ಠ ಮುಂಗಡ ಅಗತ್ಯ',
  minimumAdvance: 'ಕನಿಷ್ಠ ಮುಂಗಡ ಅಗತ್ಯ',
  minimumRecharge: 'UPI/ಕಾರ್ಡ್‌ಗೆ ಕನಿಷ್ಠ ₹1',
  mobileNumber: 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
  monthMachineSummary: 'ಈ ತಿಂಗಳ ಯಂತ್ರಗಳು',
  months: 'ತಿಂಗಳುಗಳು',
  monthTotalLabel: 'ತಿಂಗಳ ಒಟ್ಟು',
  moreAvailable: 'ಹೆಚ್ಚು ಲಭ್ಯ',
  moUnit: 'ತಿಂಗಳು',
  myBookings: 'ನನ್ನ ಬುಕಿಂಗ್‌ಗಳು',
  myClientRating: 'ನನ್ನ ಗ್ರಾಹಕ ರೇಟಿಂಗ್',
  myMachines: 'ನನ್ನ ಯಂತ್ರಗಳು',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'ನಿವ್ವಳ ಗಳಿಕೆ (ತಿಂಗಳು)',
  netPaid: 'ನಿವ್ವಳ ಪಾವತಿ',
  netPayable: 'ನಿವ್ವಳ ಪಾವತಿಸಬೇಕಾದ',
  netReceived: 'ನಿವ್ವಳ ಸ್ವೀಕರಿಸಿದ',
  netReceivedCaps: 'ನಿವ್ವಳ ಸ್ವೀಕರಿಸಿದ',
  neverText: 'ಎಂದಿಗೂ ಇಲ್ಲ',
  newBooking: 'ಹೊಸ ಬುಕಿಂಗ್',
  newClientRegister: 'ಹೊಸ ಗ್ರಾಹಕ? ಇಲ್ಲಿ ನೋಂದಣಿ',
  newClientRegistration: 'ಹೊಸ ಗ್ರಾಹಕ ನೋಂದಣಿ',
  newPassword: 'ಹೊಸ ಪಾಸ್‌ವರ್ಡ್',
  nextText: 'ಮುಂದೆ',
  noAlerts: 'ಯಾವುದೇ ಎಚ್ಚರಿಕೆಗಳಿಲ್ಲ!',
  noAlertsNow: 'ಈಗ ಎಚ್ಚರಿಕೆಗಳಿಲ್ಲ.',
  noBankRefund: '❌ ಬ್ಯಾಂಕ್ ರಿಫಂಡ್ ಇಲ್ಲ — ವಾಲೆಟ್ ಕ್ರೆಡಿಟ್ ಮಾತ್ರ',
  noBookings: 'ಸಕ್ರಿಯ ಬುಕಿಂಗ್‌ಗಳಿಲ್ಲ',
  noBookingsAccount: 'ಈ ಖಾತೆಗೆ ಇನ್ನೂ ಬುಕಿಂಗ್ ಇಲ್ಲ.',
  noBookingsYet: 'ಇನ್ನೂ ಬುಕಿಂಗ್ ಇಲ್ಲ',
  noClientFeedbackYet: 'ಇನ್ನೂ ಗ್ರಾಹಕ ರೇಟಿಂಗ್‌ಗಳಿಲ್ಲ. ಡಿಸ್ಪ್ಯಾಚ್ ನಂತರ ಗ್ರಾಹಕ ಪ್ರತಿಕ್ರಿಯೆ ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.',
  noDlqItems: 'DLQ ಅಂಶಗಳಿಲ್ಲ',
  noFileSelected: 'ಫೈಲ್ ಆಯ್ಕೆ ಮಾಡಿಲ್ಲ',
  noMachinesDashboard: 'ಇನ್ನೂ ಯಂತ್ರಗಳಿಲ್ಲ. ನಿಮ್ಮ ಫ್ಲೀಟ್ ಸೇರಿಸಲು ಯಂತ್ರ ನೋಂದಣಿ ಬಳಸಿ.',
  noMachinesTrack: 'ಟ್ರ್ಯಾಕ್ ಮಾಡಲು ಯಂತ್ರಗಳಿಲ್ಲ',
  noMachinesTrackHint: 'GPS ಟ್ರ್ಯಾಕಿಂಗ್‌ಗಾಗಿ ಯಂತ್ರ ನೋಂದಣಿ ಮಾಡಿ.',
  noMachinesYet: 'ಇನ್ನೂ ಯಂತ್ರಗಳು ನೋಂದಾಯಿಸಲಾಗಿಲ್ಲ',
  noMoreAuditLogs: 'ಪ್ರಸ್ತುತ ಫಿಲ್ಟರ್‌ಗಳಿಗೆ ಹೆಚ್ಚು ಆಡಿಟ್ ಲಾಗ್‌ಗಳಿಲ್ಲ.',
  noRecentApiSloBreach: 'ಇತ್ತೀಚೆ API SLO breach ಸಂಕೇತಗಳಿಲ್ಲ.',
  noRecentFailedLogins: 'ಇತ್ತೀಚೆ ವಿಫಲ ಲಾಗಿನ್ ಪ್ರಯತ್ನಗಳಿಲ್ಲ.',
  noRefund: 'ರಿಫಂಡ್ ಇಲ್ಲ ನೀತಿ',
  normalText: 'ಸಾಧಾರಣ',
  noSecuritySignalsFound: 'ಭದ್ರತಾ ಸಂಕೇತಗಳು ಕಂಡುಬಂದಿಲ್ಲ.',
  noTransactionsFilter: 'ಆಯ್ಕೆಮಾಡಿದ ಫಿಲ್ಟರ್‌ಗೆ ವಹಿವಾಟುಗಳಿಲ್ಲ.',
  off: 'OFF',
  officeLabel: 'ಆಫೀಸ್',
  on: 'ON',
  operator: 'ಆಪರೇಟರ್',
  operatorFeedbackColumn: 'ಆಪರೇಟರ್ ಪ್ರತಿಕ್ರಿಯೆ',
  operatorFeedbackSaved: 'ಧನ್ಯವಾದ! ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆ ಉಳಿಸಲಾಗಿದೆ.',
  operatorFeedbackSubmitted: 'ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆ',
  operatorFeedbackTitle: 'ಆಪರೇಟರ್ ಪ್ರತಿಕ್ರಿಯೆ',
  operatorPortal: 'ಆಪರೇಟರ್ ಪೋರ್ಟಲ್',
  operatorRole: 'ಆಪರೇಟರ್',
  operators: 'ಆಪರೇಟರ್‌ಗಳು',
  operatorSatisfactionQuestion: 'ನೀವು ಆಪರೇಟರ್‌ನಿಂದ ತೃಪ್ತರಾಗಿದ್ದೀರಾ?',
  operatorSuggestionPlaceholder: 'ಸಲಹೆ ಅಥವಾ ಪ್ರತಿಕ್ರಿಯೆ (ಐಚ್ಛಿಕ)',
  optionalLabel: '(ಐಚ್ಛಿಕ)',
  otpCode: 'OTP ಕೋಡ್',
  overview: 'ಅವಲೋಕನ',
  ownerBookingsAllLoaded: ' (ಎಲ್ಲಾ ಲೋಡ್)',
  ownerBookingsMoreAvailable: ' (ಇನ್ನೂ ಲಭ್ಯ)',
  ownerInfo: 'ಮಾಲೀಕ ಮಾಹಿತಿ',
  ownerPortal: 'ಮಾಲೀಕರ ಪೋರ್ಟಲ್',
  ownerRole: 'ಯಂತ್ರ ಮಾಲೀಕ',
  owners: 'ಮಾಲೀಕರು',
  password: 'ಪಾಸ್‌ವರ್ಡ್',
  passwordsMustMatch: 'ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತು ದೃಢೀಕರಣ ಒಂದೇ ಆಗಿರಬೇಕು.',
  pastIssuesTitle: 'ಹಿಂದಿನ ಸಮಸ್ಯೆಗಳು',
  paymentBreakdownTitle: 'ಪಾವತಿ ವಿವರಗಳು — April 2026',
  paymentCycle: 'ಪಾವತಿ ಚಕ್ರ',
  paymentFailed: 'ಪಾವತಿ ವಿಫಲ! ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  paymentHistory: 'ಪಾವತಿ ಇತಿಹಾಸ',
  paymentHistoryTitle: 'ಪಾವತಿ ಇತಿಹಾಸ',
  paymentMethods: 'ಪಾವತಿ ವಿಧಾನಗಳು',
  paymentMode: 'ಪಾವತಿ ವಿಧಾನ',
  paymentSuccess: 'ಪಾವತಿ ಯಶಸ್ವಿ!',
  payNow: 'ಈಗ ಪಾವತಿಸಿ',
  payNowText: 'ಈಗ ಪಾವತಿಸಿ',
  pdfInvoiceFailed: 'ಇನ್‌ವಾಯ್ಸ್ PDF ರಚಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  pdfReportFailed: 'ವರದಿ PDF ರಚಿಸಲಾಗಲಿಲ್ಲ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  pdiCompleted: '✅ PDI / Safety inspection ಪೂರ್ಣ',
  pdiCrawlerHint: 'Crawler plant: pollution (PUC) ಅಗತ್ಯವಿಲ್ಲ — ಯಂತ್ರ RTO road-registered ಅಲ್ಲ.',
  pdiInfo: 'PDI ತಪಾಸಣೆ',
  pdiInsuranceApplicable: '✅ Insurance / cover (if applicable)',
  pdiInsuranceValid: '✅ Insurance valid & up to date',
  pdiPollutionValid: '✅ Pollution certificate (PUC) valid',
  pdiTitle: 'Pre-Delivery Inspection (PDI)',
  penaltyDeduct: 'ರದ್ದು ದಂಡ (1 ಗಂಟೆ)',
  pending: 'ಬಾಕಿ',
  pendingApproval: 'ಅನುಮೋದನೆ ಬಾಕಿ',
  pendingCount: '{count} ಬಾಕಿ',
  pendingDispatch: 'ಡಿಸ್ಪ್ಯಾಚ್ ಬಾಕಿ',
  perDay: 'ದಿನಕ್ಕೆ',
  perHour: 'ಗಂಟೆಗೆ',
  perMonth: 'ತಿಂಗಳಿಗೆ',
  perWeek: 'ವಾರಕ್ಕೆ',
  phone: 'ಫೋನ್',
  platform: 'ನಿರ್ಮಾಣ ನಿರ್ವಹಣಾ ವೇದಿಕೆ',
  platformAgreement: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಒಪ್ಪಂದ',
  policyLabel: 'ನೀತಿ',
  policyTopicBooking: 'ಬುಕಿಂಗ್',
  policyTopicCancellation: 'ರದ್ದು',
  policyTopicContact: 'ಸಂಪರ್ಕ',
  policyTopicGst: 'GST',
  policyTopicHours: 'ಸಪೋರ್ಟ್ ಸಮಯ',
  portalBackLink: 'ಪೋರ್ಟಲ್',
  portalClient: 'ಗ್ರಾಹಕ',
  portalClientSub: 'ಮೆಷಿನರಿ ಬುಕ್ ಮಾಡಿ',
  portalNewClientRegister: 'ಹೊಸ ಗ್ರಾಹಕ? ನೋಂದಣಿ',
  portalNewOwnerRegister: 'ಹೊಸ ಮಾಲೀಕ? ನೋಂದಣಿ',
  portalOwner: 'ಮಾಲೀಕ',
  portalOwnerSub: 'ಫ್ಲೀಟ್ ನಿರ್ವಹಣೆ',
  portalStaffAdmin: 'ಅಡ್ಮಿನ್',
  portalStaffOperator: 'ಆಪರೇಟರ್',
  portalWelcome: 'ಸ್ವಾಗತ',
  portalWelcomeHint: 'ಮುಂದುವರಿಯಲು ನಿಮ್ಮ ಪೋರ್ಟಲ್ ಆಯ್ಕೆ ಮಾಡಿ',
  quantityLabel: 'ಪ್ರಮಾಣ',
  quickIssueReport: 'ತ್ವರಿತ ಸಮಸ್ಯೆ ವರದಿ',
  quickRechargeUpi: 'UPI ಮೂಲಕ ತ್ವರಿತ ರೀಚಾರ್ಜ್',
  quickSelect: 'ತ್ವರಿತ ಆಯ್ಕೆ:',
  rateCard: 'ದರ ಕಾರ್ಡ್ (ಆಪರೇಟರ್ ಸೇರಿ)',
  rateLimitTelemetryTitle: 'Rate Limit Telemetry',
  rateOperatorWork: 'ಆಪರೇಟರ್ ಕೆಲಸ ರೇಟ್ ಮಾಡಿ (1–5 stars)',
  rating: 'ರೇಟಿಂಗ್',
  receiptId: 'ರಸೀದಿ ID',
  recentAlerts: 'ಇತ್ತೀಚಿನ ಎಚ್ಚರಿಕೆಗಳು',
  recentFailedLoginsTitle: 'ಇತ್ತೀಚಿನ ವಿಫಲ ಲಾಗಿನ್‌ಗಳು',
  recentLabel: 'ಇತ್ತೀಚಿನ',
  recharge: 'ರೀಚಾರ್ಜ್',
  rechargeFirst: '⚡ ಮೊದಲು ವಾಲೆಟ್ ರೀಚಾರ್ಜ್ ಮಾಡಿ',
  rechargeWallet: '+ ವಾಲೆಟ್ ರೀಚಾರ್ಜ್',
  ref: 'ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ',
  refreshingText: 'ರಿಫ್ರೆಶ್ ಆಗುತ್ತಿದೆ...',
  refreshText: 'ರಿಫ್ರೆಶ್',
  regCapacitySpecs: 'ಸಾಮರ್ಥ್ಯ / ವಿವರಗಳು',
  regDocCrawlerHint: 'Crawler (excavator): chassis plate, machine purchase invoice, machine photo ಮತ್ತು ID ಅಗತ್ಯ. Insurance optional.',
  regDocWheeledHint: 'Wheeled: RC (RTO), insurance, PUC ಮತ್ತು ID ಅಗತ್ಯ (ಪ್ರತಿ 5MB).',
  regEquipmentCategory: 'ಸಾಮಗ್ರಿ ವರ್ಗ *',
  regFailed: 'ನೋಂದಣಿ ವಿಫಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.',
  regFileSizeError: 'ಪ್ರತಿ document 5MB ಅಥವಾ ಕಡಿಮೆ ಇರಬೇಕು',
  regFileTypeError: 'PDF, JPG, PNG ಅಥವಾ WEBP ಫೈಲ್‌ಗಳು ಮಾತ್ರ ಅನುಮತಿಸಲಾಗಿದೆ',
  regFleetIdOptional: 'ಫ್ಲೀಟ್ / ಚಾಸಿಸ್ ID (ಐಚ್ಛಿಕ)',
  register: 'ಯಂತ್ರ ನೋಂದಣಿ',
  registerAction: 'ನೋಂದಣಿ',
  registering: 'ನೋಂದಣಿ ಆಗುತ್ತಿದೆ...',
  registerMachine: 'ಯಂತ್ರ ನೋಂದಣಿ',
  registrationPending: 'ಅಡ್ಮಿನ್ 24 ಗಂಟೆಗಳಲ್ಲಿ ನಿಮ್ಮ ಖಾತೆಯನ್ನು ಸಕ್ರಿಯಗೊಳಿಸುತ್ತಾರೆ.',
  registrationSuccess: 'ನೋಂದಣಿ ಯಶಸ್ವಿ!',
  regMachineCategory: 'ಯಂತ್ರ ವರ್ಗ *',
  regMachineInfoTitle: 'ಯಂತ್ರ ಮಾಹಿತಿ',
  regMachineIntro: 'ನಿರ್ಮಾಣ heavy equipment ಮಾತ್ರ — ಟ್ರಕ್/ಟ್ರಾನ್ಸ್‌ಪೋರ್ಟ್ ಇಲ್ಲ. Wheeled plant (ಉದಾ. JCB 3DX) ಗೆ RTO; crawler plant (Poclain, dozer) ಸೈಟ್-ಮಾತ್ರ — RTO passing ಇಲ್ಲ.',
  regMachineNameModel: 'ಯಂತ್ರ ಹೆಸರು / ಮಾದರಿ',
  regMobilityTracked: 'Crawler',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer, crawler crane — ಸೈಟ್ plant, RTO passing ಇಲ್ಲ',
  regMobilityWheeled: 'Wheeled',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) ಇರುವ ನಿರ್ಮಾಣ plant',
  machineFinancialSection: 'ಯಂತ್ರ ಖರೀದಿ ವಿವರಗಳು (ಐಚ್ಛಿಕ)',
  machineOwnershipType: 'ಮಾಲೀಕತ್ವ ಪ್ರಕಾರ',
  machineOwnershipNew: 'ಹೊಸ ಯಂತ್ರ',
  machineOwnershipUsed: 'ಮೂಲ ಮಾಲೀಕ',
  machineOwnershipSecondHand: 'ಪೂರ್ವ-ಮಾಲೀಕತ್ವ',
  machinePurchasePrice: 'ಖರೀದಿ ಬೆಲೆ (₹)',
  machinePurchasePriceHint: 'ಈ ಯಂತ್ರಕ್ಕಾಗಿ ನೀವು ಪಾವತಿಸಿದ ಮೊತ್ತ',
  machinePurchaseDate: 'ಖರೀದಿ ದಿನಾಂಕ',
  machineYearOfManufacture: 'ತಯಾರಿಕೆ ವರ್ಷ',
  machineLoanSection: 'ಈ ಯಂತ್ರದ ಮೇಲೆ ನನಗೆ loan ಇದೆ',
  machineLoanAmount: 'Loan ಮೊತ್ತ (₹)',
  machineLoanEmi: 'ಮಾಸಿಕ EMI (₹)',
  machineLoanTenure: 'Loan ಅವಧಿ (ತಿಂಗಳು)',
  machineLoanStartDate: 'Loan ಪ್ರಾರಂಭ ದಿನಾಂಕ',
  machineFuelConsumption: 'ಇಂಧನ ಬಳಕೆ (L/hr)',
  machineMonthlyOperatingExpenses: 'ಮಾಸಿಕ ಕಾರ್ಯಾಚರಣೆ ವೆಚ್ಚ',
  machineOperatorMonthlySalary: 'ಆಪರೇಟರ್ ಮಾಸಿಕ ವೇತನ',
  machineServiceMonthly: 'ಸರ್ವೀಸ್ / ನಿರ್ವಹಣೆ (ಮಾಸಿಕ)',
  machineBreakdownMonthly: 'ಬ್ರೇಕ್‌ಡೌನ್ / ದುರಸ್ತಿ (ಮಾಸಿಕ ಸರಾಸರಿ)',
  machineMaterialsMonthly: 'ಸಾಮಗ್ರಿ / ಉಪಯೋಗಿಸಬಹುದಾದ (ಮಾಸಿಕ)',
  recoveryPlan: 'ರಿಕವರಿ ಪ್ಲಾನ್',
  recoveryOnTrack: 'ಸರಿಯಾದ ದಾರಿಯಲ್ಲಿ',
  recoveryNeedsAttention: 'ಗಮನ ಅಗತ್ಯ',
  recoveryActionRequired: 'ಕ್ರಮ ಅಗತ್ಯ',
  recoveryAddPrice: 'ರಿಕವರಿ ಪ್ಲಾನ್ ನೋಡಲು ಖರೀದಿ ಬೆಲೆ ಸೇರಿಸಿ',
  recoveryProgress: 'ಹೂಡಿಕೆ ವಸೂಲು',
  recoveryDailyNet: 'ದೈನಂದಿನ ನಿವ್ವಳ ಆದಾಯ',
  recoveryDays: 'ಚೇತರಿಕೆ ಅವಧಿ',
  recoveryProjectedDate: 'ಅಂದಾಜು ಚೇತರಿಕೆ ದಿನಾಂಕ',
  recoveryRoi: 'ವಾರ್ಷಿಕ ಆದಾಯ',
  recoveryCurrentValue: 'ಪ್ರಸ್ತುತ ಯಂತ್ರ ಮೌಲ್ಯ',
  editFinancialDetails: 'ಹಣಕಾಸು ವಿವರಗಳನ್ನು ಸಂಪಾದಿಸಿ',
  financialDetailsSaved: 'ಹಣಕಾಸು ವಿವರಗಳು ಉಳಿಸಲಾಗಿದೆ',
  recoveryBackfillNudge: 'ರಿಕವರಿ ಟ್ರ್ಯಾಕಿಂಗ್ ಅನ್‌ಲಾಕ್ ಮಾಡಲು {{count}} ಮೆಷಿನ್(ಗಳು)ಗೆ ಖರೀದಿ ವಿವರಗಳನ್ನು ಸೇರಿಸಿ',
  dieselPriceTitle: 'ಡೀಜಲ್ ಬೆಲೆ',
  dieselPriceUpdate: 'ಡೀಜಲ್ ಬೆಲೆ ಅಪ್‌ಡೇಟ್ ಮಾಡಿ',
  dieselPriceLatest: 'ಇತ್ತೀಚಿನ ಬೆಲೆ',
  dieselPriceNoRecord: 'ಡೀಜಲ್ ಬೆಲೆ ದಾಖಲಾಗಿಲ್ಲ',
  dieselPricePerLitre: 'ಲೀಟರ್ ಬೆಲೆ (₹)',
  dieselQuantity: 'ತುಂಬಿದ ಪ್ರಮಾಣ (ಲೀಟರ್)',
  dieselTaluka: 'ನಗರ / ಪ್ರದೇಶ',
  bookingAttachment: 'ಅಟ್ಯಾಚ್‌ಮೆಂಟ್ ಆಯ್ಕೆಮಾಡಿ',
  bookingAttachmentNone: 'ನಿರ್ದಿಷ್ಟ ಅಟ್ಯಾಚ್‌ಮೆಂಟ್ ಇಲ್ಲ',
  bookingWorkDescription: 'ಕೆಲಸದ ವಿವರ',
  bookingWorkDescriptionPlaceholder: 'ಉದಾ. ಅಡಿಪಾಯ ಅಗೆಯುವಿಕೆ, ಟ್ರೆಂಚಿಂಗ್, ಪೈಪ್‌ಲೈನ್ ಕೆಲಸ',
  bookingAttachmentLabel: 'ಅಟ್ಯಾಚ್‌ಮೆಂಟ್',
  bookingSiteLabel: 'ಸೈಟ್',
  bookingWorkLabel: 'ಕೆಲಸ',
  termsAccept: "ನಾನು ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳಿಗೆ ಸಮ್ಮತಿಸುತ್ತೇನೆ",
  termsRequired: "ನೋಂದಣಿಗೆ ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳಬೇಕು",
  termsLink: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
  clientBlacklisted: "ಬ್ಲ್ಯಾಕ್‌ಲಿಸ್ಟ್",
  clientBlacklistReason: "ಬ್ಲ್ಯಾಕ್‌ಲಿಸ್ಟ್ ಕಾರಣ",
  clientBlacklistConfirm: "ಈ ಕ್ಲೈಂಟ್ ಅನ್ನು ಬ್ಲ್ಯಾಕ್‌ಲಿಸ್ಟ್ ಮಾಡುವುದೇ?",
  clientUnblacklist: "ಬ್ಲ್ಯಾಕ್‌ಲಿಸ್ಟ್‌ನಿಂದ ತೆಗೆದುಹಾಕಿ",
  blacklistedClients: "ಬ್ಲ್ಯಾಕ್‌ಲಿಸ್ಟ್ ಕ್ಲೈಂಟ್‌ಗಳು",
  blacklistedClientsEmpty: "ಬ್ಲ್ಯಾಕ್‌ಲಿಸ್ಟ್ ಕ್ಲೈಂಟ್‌ಗಳಿಲ್ಲ",
  managerAccessRestricted: "ಹಣಕಾಸು ಪ್ರವೇಶ ನಿರ್ಬಂಧಿತ. ಓಮ್ ಚವಾನ್ ಅವರನ್ನು ಸಂಪರ್ಕಿಸಿ.",
  managerSection: "ಮ್ಯಾನೇಜರ್‌ಗಳು",
  managerAdd: "ಮ್ಯಾನೇಜರ್ ಸೇರಿಸಿ",
  managerName: "ಮ್ಯಾನೇಜರ್ ಹೆಸರು",
  managerEmail: "ಮ್ಯಾನೇಜರ್ ಇಮೇಲ್",
  managerPassword: "ತಾತ್ಕಾಲಿಕ ಪಾಸ್‌ವರ್ಡ್",
  managerCreated: "ಮ್ಯಾನೇಜರ್ ಖಾತೆ ರಚಿಸಲಾಗಿದೆ",
  managerCredentialsTitle: "ಮ್ಯಾನೇಜರ್ ಲಾಗಿನ್ ವಿವರಗಳು",
  managerCredentialsSubtitle: "ಈ ವಿವರಗಳನ್ನು ಈಗಲೇ ಉಳಿಸಿ — ಪಾಸ್‌ವರ್ಡ್ ನಂತರ ಹಿಂದಿರುಗಿಸಲಾಗುವುದಿಲ್ಲ",
  managerCredentialsSaved: "ನಾನು ವಿವರಗಳನ್ನು ಉಳಿಸಿದ್ದೇನೆ",
  managerLoginUrl: "ಲಾಗಿನ್ URL",
  managerActivity: "ಮ್ಯಾನೇಜರ್ ಚಟುವಟಿಕೆ",
  managerActivityEmpty: "ಇನ್ನೂ ಯಾವುದೇ ಚಟುವಟಿಕೆ ದಾಖಲಾಗಿಲ್ಲ",
  managerActivityViewAll: "ಎಲ್ಲಾ ಚಟುವಟಿಕೆ ನೋಡಿ",
  onboardingTitle: "ಪ್ರಾರಂಭಿಸಿ",
  onboardingAccountApproved: "ಖಾತೆ ಅನುಮೋದಿಸಲಾಗಿದೆ",
  onboardingKycComplete: "KYC ಪರಿಶೀಲನೆ ಪೂರ್ಣ",
  onboardingKycPending: "KYC ಪರಿಶೀಲನೆ ಪೂರ್ಣಗೊಳಿಸಿ",
  onboardingKycRejected: "KYC ತಿರಸ್ಕರಿಸಲಾಗಿದೆ — ಮತ್ತೆ ಸಲ್ಲಿಸಿ",
  onboardingWalletFunded: "ವಾಲೆಟ್‌ನಲ್ಲಿ ಬ್ಯಾಲೆನ್ಸ್ ಇದೆ",
  onboardingWalletEmpty: "ಬುಕಿಂಗ್‌ಗಾಗಿ ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಸೇರಿಸಿ",
  pushEnablePrompt: "ತ್ವರಿತ ಅಪ್‌ಡೇಟ್‌ಗಳಿಗಾಗಿ ಪುಶ್ ಅಧಿಸೂಚನೆಗಳನ್ನು ಆನ್ ಮಾಡಿ",
  downloadDisputeStatement: "ವಿವಾದ ಹೇಳಿಕೆ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
  downloadInvoice: "ಇನ್‌ವಾಯ್ಸ್ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
  bookAgain: "ಮತ್ತೆ ಬುಕ್ ಮಾಡಿ",
  machineNoLongerAvailable: "ಯಂತ್ರ ಇನ್ನು ಲಭ್ಯವಿಲ್ಲ",
  downloadHistoryPdf: "ಇತಿಹಾಸ PDF ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
  onboardingFirstBooking: "ನಿಮ್ಮ ಮೊದಲ ಬುಕಿಂಗ್ ಮಾಡಿ",
  onboardingAllDone: "ನೀವು ಸಿದ್ಧರಾಗಿದ್ದೀರಿ!",
  onboardingTrackerTitle: "ಆನ್‌ಬೋರ್ಡಿಂಗ್ ಪ್ರಗತಿ",
  onboardingTrackerTarget: "ಆನ್‌ಬೋರ್ಡಿಂಗ್ ಗುರಿ: 48 ಗಂಟೆ",
  onboardingTrackerInProgress: "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
  onboardingTrackerActionRequired: "ಕ್ರಮ ಬೇಕು",
  onboardingTrackerComplete: "ಪೂರ್ಣ",
  onboardingTrackerPending: "ಬಾಕಿ",
  onboardingTrackerPhase1: "ನೋಂದಣಿ",
  onboardingTrackerPhase2: "KYC ಪರಿಶೀಲನೆ",
  onboardingTrackerPhase3: "ಯಂತ್ರ ನೋಂದಣಿ",
  onboardingTrackerPhase4: "ಮೊದಲ ಬುಕಿಂಗ್ ಸಿದ್ಧ",
  onboardingTrackerHelper1: "ಯಂತ್ರ ನೋಂದಣಿ ತೆರೆಯಲು ಆಧಾರ್ + ಸೆಲ್ಫಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
  onboardingTrackerHelper2: "KYC ಪರಿಶೀಲನೆಯಲ್ಲಿ — ಸಾಮಾನ್ಯವಾಗಿ 24 ಗಂಟೆಗಳಲ್ಲಿ",
  onboardingTrackerHelper3: "KYC ತಿರಸ್ಕರಿಸಲಾಗಿದೆ — ದಾಖಲೆಗಳನ್ನು ಮತ್ತೆ ಸಲ್ಲಿಸಿ",
  onboardingTrackerHelper4: "KYC ಅನುಮೋದನೆ — ನಿಮ್ಮ ಮೊದಲ ಯಂತ್ರವನ್ನು ಸೇರಿಸಿ",
  onboardingTrackerHelper5: "ಯಂತ್ರ ನಿರ್ವಾಹಕ ಪರಿಶೀಲನೆಯಲ್ಲಿ",
  onboardingTrackerHelper6: "ಯಂತ್ರ ಲೈವ್ — ಮೊದಲ ಬುಕಿಂಗ್‌ಗಾಗಿ ಕಾಯುತ್ತಿದೆ",
  onboardingTrackerPhaseLabel: "ಹಂತ",
  alertsAndNotifications: 'ಎಚ್ಚರಿಕೆಗಳು ಮತ್ತು ಅಧಿಸೂಚನೆಗಳು',
  dieselFuelCostPerHour: 'ಗಂಟೆಗೆ ಇಂಧನ ವೆಚ್ಚ',
  dieselPercentOfRate: 'ನಿಮ್ಮ ಗಂಟೆ ದರದ',
  dieselPriceSaved: 'ಡೀಜಲ್ ಬೆಲೆ ಉಳಿಸಲಾಗಿದೆ',
  dieselRateSuggestion: 'ದರ ಸಲಹೆ',
  dieselRateIncrease: 'ಡೀಜಲ್ ಹೆಚ್ಚಾಗಿದೆ — ದರ ಹೆಚ್ಚಿಸಲು ಪರಿಗಣಿಸಿ',
  dieselRateDecrease: 'ಡೀಜಲ್ ಕಡಿಮೆಯಾಗಿದೆ — ಬುಕಿಂಗ್‌ಗಾಗಿ ದರ ಕಡಿಮೆ ಮಾಡಿ',
  dieselSuggestedRate: 'ಸೂಚಿಸಿದ ದರ',
  dieselHistory: 'ಬೆಲೆ ಇತಿಹಾಸ',
  dieselNoHistory: 'ಇನ್ನೂ ಡೀಜಲ್ ಬೆಲೆ ಇತಿಹಾಸ ಇಲ್ಲ',
  dieselColDate: 'ದಿನಾಂಕ',
  dieselColPrice: 'ಬೆಲೆ/ಲೀಟರ್',
  dieselColQty: 'ಪ್ರಮಾಣ',
  dieselColSource: 'ಮೂಲ',
  dieselUploadReceipt: 'ರಸೀದಿ ಅಪ್‌ಲೋಡ್',
  dieselExtractSuccess: 'ರಸೀದಿಯಿಂದ ಹೊರತೆಗೆದರು',
  dieselExtractFailed: 'ಹೊರತೆಗೆಯಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ — ದಯವಿಟ್ಟು ಮ್ಯಾನುಯಲ್ ನಮೂದಿಸಿ',
  applyRateSuggestion: '₹{{rate}}/ಗಂಟೆ ಅನ್ವಯಿಸಿ',
  rateSuggestionApplied: 'ದರ ಯಶಸ್ವಿಯಾಗಿ ಅಪ್‌ಡೇಟ್ ಆಯಿತು',
  marketPosition: 'ಮಾರುಕಟ್ಟೆ ಸ್ಥಿತಿ',
  marketBelowMarket: 'ಮಾರುಕಟ್ಟೆಗಿಂತ ಕಡಿಮೆ',
  marketCompetitive: 'ಸ್ಪರ್ಧಾತ್ಮಕ',
  marketAboveMarket: 'ಮಾರುಕಟ್ಟೆಗಿಂತ ಹೆಚ್ಚು',
  marketNoData: 'ನಿಮ್ಮ ಪ್ರದೇಶಕ್ಕೆ ಇನ್ನೂ ಮಾರುಕಟ್ಟೆ ಡೇಟಾ ಇಲ್ಲ',
  marketSubmitRate: 'ಮಾರುಕಟ್ಟೆ ದರ ಸಲ್ಲಿಸಿ',
  marketCity: 'ನಗರ / ಪ್ರದೇಶ',
  marketMinRate: 'ನಿಮ್ಮ ಪ್ರದೇಶದಲ್ಲಿ ಕನಿಷ್ಠ ದರ (₹/ಗಂಟೆ)',
  marketMaxRate: 'ನಿಮ್ಮ ಪ್ರದೇಶದಲ್ಲಿ ಗರಿಷ್ಠ ದರ (₹/ಗಂಟೆ)',
  marketRateSubmitted: 'ಮಾರುಕಟ್ಟೆ ದರ ಸಲ್ಲಿಸಲಾಗಿದೆ — ಧನ್ಯವಾದ!',
  marketDataPoints: '{{count}} ಸಲ್ಲಿಕೆ(ಗಳ) ಆಧಾರದ ಮೇಲೆ',
  marketRange: '{{city}} ನಲ್ಲಿ ಮಾರುಕಟ್ಟೆ',
  marketSourceLocal: '{{city}} ಪ್ರದೇಶದ ದರಗಳ ಆಧಾರದ ಮೇಲೆ',
  marketSourcePlatform: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್-ವ್ಯಾಪಿ ದರಗಳ ಆಧಾರದ ಮೇಲೆ',
  regPremiumOnboarding: 'Premium onboarding',
  regRtoNumber: 'RTO ನೋಂದಣಿ ಸಂಖ್ಯೆ *',
  regSelectType: 'ವಿಧ ಆಯ್ಕೆ ಮಾಡಿ…',
  regSubmitBtn: '✅ ನೋಂದಣಿ ಸಲ್ಲಿಸಿ',
  regTagNoRto: 'RTO ಇಲ್ಲ',
  regTagRto: 'RTO',
  regYearManufacture: 'ತಯಾರಿಕೆ ವರ್ಷ *',
  remoteLockAlert: 'Teltonika GPS device ಈ ಯಂತ್ರದಲ್ಲಿ ಸ್ಥಾಪಿಸಿದ ನಂತರ remote lock enable ಆಗುತ್ತದೆ. DE support ಸಂಪರ್ಕಿಸಿ.',
  remoteLockMachine: '🔒 ರಿಮೋಟ್ ಲಾಕ್ ಯಂತ್ರ',
  replaceFile: 'ಬದಲಿಸಿ',
  reports: 'ವರದಿಗಳು',
  reportText: 'ವರದಿ',
  resetMethodEmail: 'ಇಮೇಲ್ ಲಿಂಕ್',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಲಾಗಲಿಲ್ಲ. ಹೊಸ ಲಿಂಕ್ ವಿನಂತಿಸಿ.',
  resetPasswordIntro: 'ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳ ಬಲವಾದ ಪಾಸ್‌ವರ್ಡ್ ಆಯ್ಕೆಮಾಡಿ.',
  resetPasswordMinLength: 'ಪಾಸ್‌ವರ್ಡ್ ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳಾಗಿರಬೇಕು.',
  resetPasswordMissingToken: 'ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ಕಾಣೆಯಾಗಿದೆ ಅಥವಾ ಅಮಾನ್ಯವಾಗಿದೆ. ಲಾಗಿನ್‌ನಿಂದ Forgot password ಬಳಸಿ.',
  resetPasswordSubmit: 'ಪಾಸ್‌ವರ್ಡ್ ನವೀಕರಿಸಿ',
  resetPasswordSuccess: 'ಪಾಸ್‌ವರ್ಡ್ ನವೀಕರಿಸಲಾಗಿದೆ. ಲಾಗಿನ್‌ಗೆ ಮರುನಿರ್ದೇಶಿಸಲಾಗುತ್ತಿದೆ...',
  resetPasswordTitle: 'ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಿಸಿ',
  resetPasswordUpdating: 'ನವೀಕರಿಸಲಾಗುತ್ತಿದೆ...',
  resetText: 'ರೀಸೆಟ್',
  retryDlqItemTitle: 'DLQ ಅಂಶ ಮರು ಪ್ರಯತ್ನ',
  retryFailedForDlq: 'DLQ ಅಂಶಕ್ಕೆ ಮರು ಪ್ರಯತ್ನ ವಿಫಲ',
  retryReasonAuditPlaceholder: 'ಮರು ಪ್ರಯತ್ನ ಕಾರಣ (ಆಡಿಟ್‌ಗಾಗಿ)',
  retryText: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
  revenue: 'ಆದಾಯ',
  running: 'ಚಾಲನೆಯಲ್ಲಿದೆ',
  satisfiedNo: 'ತೃಪ್ತಿ ಇಲ್ಲ',
  satisfiedYes: 'ಹೌದು, ತೃಪ್ತಿ',
  save: 'ಉಳಿಸಿ',
  scanToPay: 'ಪಾವತಿಗಾಗಿ ಸ್ಕ್ಯಾನ್ ಮಾಡಿ',
  scheduleColFeedback: 'ಪ್ರತಿಕ್ರಿಯೆ',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'ಒಟ್ಟು',
  scheduleColType: 'ವಿಧ',
  securitySignalsTitle: 'ಭದ್ರತಾ ಸಂಕೇತಗಳು',
  selectBook: 'ಈ ಯಂತ್ರ ಬುಕ್ ಮಾಡಿ →',
  selectCalc: '📋 ಆಯ್ಕೆ ಮಾಡಿ & ವೆಚ್ಚ ನೋಡಿ →',
  selectedMachineText: 'ಆಯ್ಕೆ ಮಾಡಿದ ಯಂತ್ರ',
  selectFile: 'ಫೈಲ್ ಆಯ್ಕೆ ಮಾಡಿ',
  selectMachineFirst: 'ಮೊದಲು ಯಂತ್ರ ಆಯ್ಕೆ ಮಾಡಿ',
  selectQty: 'ಪ್ರಮಾಣ ಆಯ್ಕೆ ಮಾಡಿ',
  selectRole: 'ಪಾತ್ರ ಆಯ್ಕೆ ಮಾಡಿ',
  send: 'ಕಳುಹಿಸಿ',
  sendEmail: 'ಇಮೇಲ್ ಕಳುಹಿಸಿ',
  sendWhatsapp: 'WhatsApp ನಲ್ಲಿ ಕಳುಹಿಸಿ',
  settlements: 'ನಿಷ್ಕರ್ಷ',
  show: 'ತೋರಿಸಿ',
  signIn: 'ಸೈನ್ ಇನ್ ಮಾಡಿ',
  signingIn: 'ಲಾಗಿನ್ ಆಗುತ್ತಿದೆ...',
  signupCompanyName: 'ಕಂಪನಿ ಹೆಸರು',
  signupContactName: 'ಸಂಪರ್ಕ ಹೆಸರು',
  signupCreatePassword: 'ಪಾಸ್‌ವರ್ಡ್ ರಚಿಸಿ',
  signupReenterPassword: 'ಪಾಸ್‌ವರ್ಡ್ ಮತ್ತೆ ನಮೂದಿಸಿ',
  signupSectionCompany: 'ಕಂಪನಿ',
  signupSectionContact: 'ನಿಮ್ಮ ವಿವರಗಳು',
  signupSectionSecurity: 'ಭದ್ರತೆ',
  sinceExcellence: '2011 ರಿಂದ · 15 ವರ್ಷ ಶ್ರೇಷ್ಠತೆ',
  sinceLabel: 'ಇಂದ',
  sloBreachRisk: 'SLO BREACH RISK',
  sloHealthy: 'SLO HEALTHY',
  speed: 'ವೇಗ',
  staleText: 'ಹಳೆಯದು',
  status: 'ಸ್ಥಿತಿ',
  statusCancelled: 'ರದ್ದು',
  bookingClosed: 'ಮುಚ್ಚಲಾಗಿದೆ',
  sectionNew: 'ಹೊಸ',
  sectionAccepted: 'ಸ್ವೀಕರಿಸಲಾಗಿದೆ',
  sectionActive: 'ಸಕ್ರಿಯ',
  sectionDispatched: 'ರವಾನೆ',
  sectionCompleting: 'ಪೂರ್ಣಗೊಳ್ಳುತ್ತಿದೆ',
  sectionDisputed: 'ವಿವಾದ',
  sectionCompleted: 'ಪೂರ್ಣ',
  sectionClosed: 'ಮುಚ್ಚಲಾಗಿದೆ',
  statusCompleted: 'ಪೂರ್ಣ',
  stopped: 'ನಿಲ್ಲಿಸಲಾಗಿದೆ',
  submit: 'ಸಲ್ಲಿಸಿ',
  submitOperatorFeedback: 'ಪ್ರತಿಕ್ರಿಯೆ ಸಲ್ಲಿಸಿ',
  submittedRegistrations: 'ಸಲ್ಲಿಸಿದ ನೋಂದಣಿಗಳು',
  support: 'ಬೆಂಬಲ',
  supportPolicyBooking: 'ವಾಲೆಟ್-only ಮುಂಗಡ. ಸೈಟ್‌ನಲ್ಲಿ ನಗದು ಇಲ್ಲ.',
  supportPolicyCancellation: '1 ಗಂಟೆ ದಂಡ; ಬಾಕಿ ವಾಲೆಟ್‌ಗೆ.',
  supportPolicyContact: 'DE Support ಮಾತ್ರ — ನೇರ ಡ್ರೈವರ್ ಸಂಪರ್ಕ ನಿಷೇಧ.',
  supportPolicyGst: 'ಎಲ್ಲಾ ಇನ್‌ವಾಯ್ಸ್‌ನಲ್ಲಿ 18% GST; Reports ಟ್ಯಾಬ್‌ನಿಂದ.',
  supportPolicyHours: 'ಸೋಮ–ಶನಿ, 9–7 IST',
  tableAtt: 'Att',
  tableChange: 'ಬದಲಾವಣೆ',
  tableDay: 'ದಿನ',
  tableEnd: 'ಅಂತ್ಯ',
  tableHrs: 'ಗಂ',
  tableId: 'ID',
  tableIn: 'In',
  tableLevel: 'ಮಟ್ಟ',
  tableMonth: 'ತಿಂಗಳು',
  tableNote: 'ನೋಟ್',
  tableOut: 'Out',
  tableStart: 'ಪ್ರಾರಂಭ',
  tagline: 'ಮೂಲಸೌಕರ್ಯದ ಚಿನ್ನದ ಮಾನದಂಡ',
  tax: 'ತೆರಿಗೆ',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express ಕಮಿಷನ್: ಒಟ್ಟು ಬಿಲ್ಲಿಂಗ್‌ನ 15%',
  termFuel: 'ಯಂತ್ರದಲ್ಲಿ ಯಾವಾಗಲೂ 40%+ ಇಂಧನ ಇರಬೇಕು',
  termGps: 'GPS device (Teltonika) ಕಡ್ಡಾಯ — DE ಸ್ಥಾಪಿಸುತ್ತದೆ',
  termGstTcs: 'GST TCS: GST regulations ಪ್ರಕಾರ 1%',
  termNoDirectContact: 'ನೇರ ಗ್ರಾಹಕ ಸಂಪರ್ಕ = ತಕ್ಷಣ contract termination',
  termPaymentDays: 'ಗ್ರಾಹಕ settlement ನಂತರ 3 ಕಾರ್ಯ ದಿನಗಳಲ್ಲಿ ಪಾವತಿ',
  termTds: 'TDS deduction: Income Tax Act ಪ್ರಕಾರ 2%',
  threeWorkingDays: '3 ಕಾರ್ಯ ದಿನಗಳು',
  timeLabel: 'ಸಮಯ',
  todayText: 'ಇಂದು',
  topSourceIp: 'ಟಾಪ್ ಸೋರ್ಸ್ IP',
  total: 'ಒಟ್ಟು',
  totalAdvanceLabel: 'ಮುಂಗಡ ಪಾವತಿಸಲಾಗಿದೆ',
  totalBookingsText: 'ಒಟ್ಟು ಬುಕಿಂಗ್‌ಗಳು',
  totalMachines: 'ಒಟ್ಟು ಯಂತ್ರಗಳು',
  totalSpent: 'ಒಟ್ಟು ಖರ್ಚು',
  tracking: 'GPS ಟ್ರ್ಯಾಕಿಂಗ್',
  transactionHistoryTitle: 'ವಹಿವಾಟು ಇತಿಹಾಸ',
  transactions: 'ವಹಿವಾಟು ಇತಿಹಾಸ',
  trustStatCompliant: 'ಅನುಪಾಲನೆ',
  trustStatMachines: 'ಯಂತ್ರಗಳು',
  trustStatRating: 'ರೇಟಿಂಗ್',
  txnDescription: 'ವಿವರಣೆ',
  type: 'ವಿಧ',
  understood: '✅ ಅರ್ಥಮಾಡಿಕೊಂಡೆ — ವೇದಿಕೆ ಬಳಸುತ್ತೇನೆ',
  understoodAction: 'ಅರ್ಥಮಾಡಿಕೊಂಡೆ',
  unknownText: 'ತಿಳಿದಿಲ್ಲ',
  updateFuel: 'ಇಂಧನ ಅಪ್‌ಡೇಟ್',
  updateText: 'ಅಪ್‌ಡೇಟ್',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'ಅಪ್‌ಲೋಡ್',
  valEmail: 'ಮಾನ್ಯ ಇಮೇಲ್ ಅಗತ್ಯ',
  valMachineName: 'ಯಂತ್ರ ಹೆಸರು / model ಅಗತ್ಯ',
  valMachineType: 'ದಯವಿಟ್ಟು equipment category ಆಯ್ಕೆ ಮಾಡಿ',
  valMobility: 'ದಯವಿಟ್ಟು wheeled ಅಥವಾ crawler equipment ವಿಧ ಆಯ್ಕೆ ಮಾಡಿ',
  valOwnerName: 'ಮಾಲೀಕರ ಹೆಸರು ಅಗತ್ಯ',
  valPdiChecks: 'ದಯವಿಟ್ಟು ಎಲ್ಲಾ required checks confirm ಮಾಡಿ',
  valPdiRequired: 'PDI confirmation ಅಗತ್ಯ',
  valPhone: 'ಮಾನ್ಯ ಫೋನ್ ಸಂಖ್ಯೆ ಅಗತ್ಯ',
  valRto: 'Wheeled machines ಗೆ RTO registration number ಅಗತ್ಯ',
  valUploadMissing: 'ದಯವಿಟ್ಟು upload ಮಾಡಿ: {docs}',
  valYear: 'ಮಾನ್ಯ year (YYYY) ಅಗತ್ಯ',
  viewMachines: '→ ಯಂತ್ರಗಳು ನೋಡಿ',
  wallet: 'ವಾಲೆಟ್',
  walletBalance: 'ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್',
  walletCredit: 'ವಾಲೆಟ್ ಕ್ರೆಡಿಟ್',
  walletDebit: 'ವಾಲೆಟ್ ಡೆಬಿಟ್',
  walletDeduct: 'ಮುಂಗಡ ವಾಲೆಟ್‌ನಿಂದ ಕಡಿತಗೊಳ್ಳುತ್ತದೆ · ನಗದು ಇಲ್ಲ · GST ಸ್ವಯಂಚಾಲಿತವಾಗಿ ರಚಿಸಲ್ಪಡುತ್ತದೆ',
  walletInsufficient: '❌ ಸಾಕಾಗದು',
  walletLowRecharge: 'ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಕಡಿಮೆ — ಮುಂದಿನ ಬುಕಿಂಗ್ ಮೊದಲು ರೀಚಾರ್ಜ್',
  walletOnly: 'ವಾಲೆಟ್ ಮಾತ್ರ · ನಗದು ಸ್ವೀಕರಿಸಲಾಗದು',
  walletOnlyPolicyDesc: 'ಎಲ್ಲಾ ವಹಿವಾಟುಗಳು ವಾಲೆಟ್ ಮೂಲಕ ಮಾತ್ರ. ನಗದು ಸ್ವೀಕರಿಸಲಾಗದು.',
  walletOnlyPolicyTitle: 'ವಾಲೆಟ್-ಮಾತ್ರ ನೀತಿ',
  walletRechargeTitle: 'ವಾಲೆಟ್ ರೀಚಾರ್ಜ್',
  walletSufficient: '✅ ಮುಂದುವರಿಯಿರಿ',
  weeks: 'ವಾರಗಳು',
  whatsapp: 'WhatsApp',
  wksUnit: 'ವಾರ',
  year: 'ವರ್ಷ',
  yearsExperience: '{n} ವರ್ಷ',
  yourMessage: 'ನಿಮ್ಮ ಪ್ರಶ್ನೆ ಅಥವಾ ಸಮಸ್ಯೆ ಬರೆಯಿರಿ...',
  // --- Recent feature strings ---
  retryLabel: 'ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ',
  payrollPreview: 'ಸಂಬಳ ಪೂರ್ವಾವಲೋಕನ',
  payrollRun: 'ಸಂಬಳ ಚಲಾಯಿಸಿ',
  payrollAlreadyRun: 'ಈ ತಿಂಗಳಿಗೆ ಸಂಬಳ ಈಗಾಗಲೇ ಚಲಾಯಿಸಲಾಗಿದೆ',
  payrollGross: 'ಒಟ್ಟು ಪಾವತಿಸಬೇಕಾದ',
  payrollNet: 'ನಿವ್ವಳ ಪಾವತಿಸಬೇಕಾದ',
  payrollAdvanceDeducted: 'ಮುಂಗಡ ಕಡಿತ',
  payrollRunSuccess: 'ಸಂಬಳ ಯಶಸ್ವಿಯಾಗಿ ಚಲಾಯಿಸಲಾಗಿದೆ',
  payrollNoAmount: 'ಈ ತಿಂಗಳಿಗೆ ಪಾವತಿಸಬೇಕಾದ ಮೊತ್ತವಿಲ್ಲ',
  payrollMonth: 'ಸಂಬಳ ತಿಂಗಳು',
  exportPayrollCsv: 'ಸಂಬಳ CSV ರಫ್ತು',
  payrollExportMonth: 'ಸಂಬಳ ರಫ್ತು ತಿಂಗಳು',
  payrollDailyRate: 'ದೈನಂದಿನ ದರ',
  payrollHistory: 'ಸಂಬಳ ಇತಿಹಾಸ',
  payrollNoHistory: 'ಇನ್ನೂ ಸಂಬಳ ರನ್ ಆಗಿಲ್ಲ',
  payrollColMonth: 'ತಿಂಗಳು',
  payrollColGross: 'ಒಟ್ಟು',
  payrollColDeduction: 'ಮುಂಗಡ ಕಡಿತ',
  payrollColNet: 'ನಿವ್ವಳ ಸಂಬಳ',
  payrollColDate: 'ದಿನಾಂಕ',
  downloadPayslip: 'ಪೇ ಸ್ಲಿಪ್ ಡೌನ್‌ಲೋಡ್',
  payslipTitle: 'ಮಾಸಿಕ ಪೇ ಸ್ಲಿಪ್',
  payslipEarnings: 'ಗಳಿಕೆ',
  payslipDeductions: 'ಕಡಿತಗಳು',
  payslipDaysWorked: 'ಕೆಲಸದ ದಿನಗಳು',
  payslipGeneratedBy: 'Development Express ನಿಂದ ರಚಿಸಲಾಗಿದೆ',
  operatorPayrollTitle: 'ನನ್ನ ಸಂಬಳ',
  payrollMonthlySalary: 'ಮಾಸಿಕ ಸಂಬಳ',
  payrollCurrentMonth: 'ಪ್ರಸ್ತುತ ತಿಂಗಳು',
  payrollPreviousMonth: 'ಹಿಂದಿನ ತಿಂಗಳು',
  ownerAttendanceTitle: 'ಹಾಜರಾತಿ',
  ownerAttendanceEdit: 'ಸಂಪಾದಿಸಿ',
  ownerAttendanceSave: 'ಉಳಿಸಿ',
  ownerAttendanceNoRecords: 'ಈ ತಿಂಗಳಿಗೆ ಹಾಜರಾತಿ ದಾಖಲೆಗಳಿಲ್ಲ',
  ownerAttendanceOverrideSuccess: 'ಹಾಜರಾತಿ ನವೀಕರಿಸಲಾಗಿದೆ',
  ownerSalaryUpdated: 'ಸಂಬಳ ಯಶಸ್ವಿಯಾಗಿ ನವೀಕರಿಸಲಾಗಿದೆ',
  ownerSalaryEditBtn: 'ಸಂಬಳ ಸಂಪಾದಿಸಿ',
  ownerSalaryNotSet: 'ಸಂಬಳ ಹೊಂದಿಸಲಾಗಿಲ್ಲ — ಪೇರೋಲ್‌ಗಾಗಿ ಸಂಬಳ ಹೊಂದಿಸಿ',
  duration: "ಅವಧಿ",
  durationLabel: 'ಅವಧಿ',
  plQuotaLabel: 'PL ಕೋಟಾ',
  plUsed: 'ಬಳಸಿದ',
  plAllowed: 'ಅನುಮತಿ',
  plRemaining: 'ಉಳಿದ',
  plQuotaUpdated: 'PL ಕೋಟಾ ನವೀಕರಿಸಲಾಗಿದೆ',
  plQuotaExhausted: 'PL ಕೋಟಾ ಮುಗಿದಿದೆ — ಸಂಬಳವಿಲ್ಲದ ರಜೆಯಾಗಿ ಗುರುತಿಸಲಾಗಿದೆ',
  plRemainingLabel: 'ಉಳಿದ PL',
  noAttendanceRecords: 'ಇನ್ನೂ ಹಾಜರಾತಿ ದಾಖಲೆಗಳಿಲ್ಲ',
  noFuelLogs: 'ಇನ್ನೂ ಇಂಧನ ಲಾಗ್‌ಗಳಿಲ್ಲ',
  noIssuesYet: 'ಇನ್ನೂ ಯಾವುದೇ ಸಮಸ್ಯೆ ದಾಖಲಾಗಿಲ್ಲ',
  failedToLoad: 'ಡೇಟಾ ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
  failedToLoadReport: 'ವರದಿ ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
  failedToLoadIssues: 'ಸಮಸ್ಯೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
  failedToLoadAlerts: 'ಎಚ್ಚರಿಕೆಗಳನ್ನು ಲೋಡ್ ಮಾಡಲು ವಿಫಲವಾಗಿದೆ',
  noRecordsMonth: 'ಈ ತಿಂಗಳಿಗೆ ದಾಖಲೆಗಳಿಲ್ಲ',
  underReview: 'ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ',
  issueResolved: 'ಪರಿಹರಿಸಲಾಗಿದೆ',
  presentDaysLabel: 'ಹಾಜರಿದಿನಗಳು',
  halfDaysLabel: 'ಅರ್ಧ ದಿನಗಳು',
  absentDaysLabel: 'ಗೈರುಹಾಜರಿ ದಿನಗಳು',
  totalHmrLabel: 'ಒಟ್ಟು HMR',
  noActiveBookingIdle: 'ಸಕ್ರಿಯ ಬುಕಿಂಗ್ ಇಲ್ಲ — ಮಶೀನ್ ನಿಷ್ಕ್ರಿಯ',
  siteLocationNotCaptured: 'ಸೈಟ್ ಸ್ಥಳ ದಾಖಲಾಗಿಲ್ಲ',
  siteLocationNotAvailable: 'ಸೈಟ್ ಸ್ಥಳ ಲಭ್ಯವಿಲ್ಲ',
  bookingRefLabel: 'ಬುಕಿಂಗ್ Ref',
  alertPendingBookings: 'ಬಾಕಿ ಬುಕಿಂಗ್‌ಗಳು',
  alertPendingPayouts: 'ಬಾಕಿ ಪೇಮೆಂಟ್‌ಗಳು',
  alertLowFuel: 'ಕಡಿಮೆ ಇಂಧನ',
  alertOpenIssues: 'ತೆರೆದ ಸಮಸ್ಯೆಗಳು',
  noMachineRunning: 'ಪ್ರಸ್ತುತ ಯಾವುದೇ ಮಶೀನ್ ಚಾಲನೆಯಲ್ಲಿಲ್ಲ',
  trackingEmptyHint: 'ಮಶೀನ್ ರವಾನೆಯಾದ ನಂತರ ನಿಮ್ಮ ಸಕ್ರಿಯ ಬುಕಿಂಗ್ ಇಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.',
  trackingUpdatedEvery5s: 'ಪ್ರತಿ 5 ಸೆಕೆಂಡುಗಳಿಗೆ ನವೀಕರಿಸಲಾಗುತ್ತದೆ',
  fuelLastOperatorUpdate: '(ಕೊನೆಯ ಒಪರೇಟರ್ ನವೀಕರಣ)',
  alertExtensionPending: 'ಬುಕಿಂಗ್ ವಿಸ್ತರಣೆ ಬಾಕಿ',
  alertConfirmCompletion: 'ದಯವಿಟ್ಟು ಕೆಲಸ ಪೂರ್ಣಗೊಳಿಸುವುದನ್ನು ದೃಢೀಕರಿಸಿ',
  alertWalletCredited: 'ವಾಲೆಟ್‌ಗೆ ಸೇರಿಸಲಾಗಿದೆ',
  alertFeedbackRequest: 'ಕೆಲಸ ಪೂರ್ಣ — ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆ ಹಂಚಿಕೊಳ್ಳಿ',
  noLogsYet: 'ಇನ್ನೂ ಯಾವುದೇ ಚಟುವಟಿಕೆ ದಾಖಲಾಗಿಲ್ಲ',
  todayActivityLog: 'ಇಂದಿನ ಚಟುವಟಿಕೆ ಲಾಗ್',
  machineLogSubtitle: 'ಇಂಧನ, ಹಾಜರಿ, ಸಮಸ್ಯೆಗಳು — ಸ್ಥಳೀಯ ಅಧಿವೇಶನ ಲಾಗ್',
  timerPaused: 'Timer ವಿರಾಮಗೊಳಿಸಲಾಗಿದೆ',
  liveBookingTitle: 'ಲೈವ್ ಬುಕಿಂಗ್',
  machineLogTimerHint: 'Timer Admin ಪ್ರಾರಂಭಿಸುತ್ತಾರೆ. ಕೆಳಗೆ ನಿಮ್ಮ ನಿಜವಾದ ಕೆಲಸದ ಸಮಯವನ್ನು ದಾಖಲಿಸಿ — ಪೂರ್ಣವಾದ ನಂತರ Mark Work Complete ಕ್ಲಿಕ್ ಮಾಡಿ.',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'ಹಾಜರಾತಿ',
  ownerAlertBookingPending: 'ಹೊಸ ಬುಕಿಂಗ್ ನಿಮ್ಮ ಅನುಮೋದನೆಗಾಗಿ ಬಾಕಿ —',
  ownerAlertBookingHours: 'ಗಂಟೆಗಳು',
  ownerAlertPayoutPending: '₹{{amount}} ಪಾವತಿ ವರ್ಗಾವಣೆಗೆ ಬಾಕಿ',
  ownerAlertFuelLow: 'ಇಂಧನ ಕಡಿಮೆ',
  ownerAlertFuelRemaining: 'ಉಳಿದಿದೆ',
  ownerAlertIssue: 'ಸಮಸ್ಯೆ ದಾಖಲು',
  iotGpsDevicesActive: 'GPS ಸಾಧನಗಳು ಸಕ್ರಿಯ',
  iotDashcamsOnline: 'ಡ್ಯಾಶ್‌ಕ್ಯಾಮ್‌ಗಳು ಆನ್‌ಲೈನ್',
  iotFuelSensorsActive: 'ಇಂಧನ ಸೆನ್ಸಾರ್‌ಗಳು ಸಕ್ರಿಯ',
  iotMachinesLocked: 'ಯಂತ್ರಗಳು ಲಾಕ್',
  iotDeviceStatus: 'IoT ಸಾಧನ ಸ್ಥಿತಿ',
  iotColMachine: 'ಯಂತ್ರ',
  iotColGps: 'GPS',
  iotColLocation: 'ಸ್ಥಳ',
  iotColFuel: 'ಇಂಧನ %',
  iotColDashcam: 'ಡ್ಯಾಶ್‌ಕ್ಯಾಮ್',
  iotColIgnition: 'ಇಗ್ನಿಷನ್',
  iotColAction: 'ಕ್ರಿಯೆ',
  iotStatusOnline: 'ಆನ್‌ಲೈನ್',
  iotStatusNotConnected: 'ಸಂಪರ್ಕವಾಗಿಲ್ಲ',
  iotStatusLive: 'ಲೈವ್',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'ಲಾಕ್',
  iotNotConnectedBanner: 'IoT ಹಾರ್ಡ್‌ವೇರ್ ಇನ್ನೂ ಸ್ಥಾಪಿಸಲಾಗಿಲ್ಲ. Teltonika ಸಾಧನ ಸ್ಥಾಪನೆಯ ನಂತರ GPS, ಡ್ಯಾಶ್‌ಕ್ಯಾಮ್ ಮತ್ತು ರಿಮೋಟ್ ಲಾಕ್ ವೈಶಿಷ್ಟ್ಯಗಳು ಲಭ್ಯವಾಗುತ್ತವೆ.',
  fuelUpdateTitle: 'ಇಂಧನ ಅಪ್ಡೇಟ್',
  fuelSensorAccuracyNote: 'ಆಪರೇಟರ್ ದಾಖಲಿಸಿದ ಇಂಧನ ಮಟ್ಟ · ಕೈಯಾರೆ ನಮೂದು',
  bookingsTab: 'ಬುಕಿಂಗ್‌ಗಳು',
  unknownLabel: 'ಅಜ್ಞಾತ',
  naLabel: 'N/A',
  baseLabel: 'ಆಧಾರ',
  qtyLabel: 'ಪ್ರಮಾಣ',
  actualHrsLabel: 'ನಿಜವಾದ ಗಂಟೆಗಳು',
  auditStatTotal: 'ಒಟ್ಟು',
  auditStatSecurity: 'ಭದ್ರತೆ',
  auditStatActors: 'ಕ್ರಿಯೆಗಾರರು',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'ಪರವಾನಗಿ',
  kycDocAadhaarFront: 'Aadhaar ಮುಂಭಾಗ',
  kycDocAadhaarBack: 'Aadhaar ಹಿಂಭಾಗ',
  kycDocPoliceVerification: 'ಪೊಲೀಸ್ ಪರಿಶೀಲನೆ',
  kycVerification: 'KYC ಪರಿಶೀಲನೆ',
  kycNotSubmitted: 'KYC ಸಲ್ಲಿಸಲಾಗಿಲ್ಲ',
  kycUnderReview: 'KYC ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ',
  kycVerified: 'KYC ದೃಢೀಕರಿಸಲಾಗಿದೆ',
  kycRejected: 'KYC ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
  kycAadhaarFront: 'Aadhaar ಮುಂಭಾಗ',
  kycAadhaarBack: 'Aadhaar ಹಿಂಭಾಗ',
  kycSelfie: 'ಸೆಲ್ಫಿ',
  kycSubmitBtn: 'KYC ದಾಖಲೆಗಳನ್ನು ಸಲ್ಲಿಸಿ',
  kycSubmitSuccess: 'ದಾಖಲೆಗಳು ಸಲ್ಲಿಸಲಾಗಿದೆ — ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ',
  kycResubmit: 'ದಾಖಲೆಗಳನ್ನು ಮತ್ತೆ ಸಲ್ಲಿಸಿ',
  adminKycTitle: 'ಕ್ಲೈಂಟ್ KYC ಪರಿಶೀಲನೆ',
  adminKycAllFilter: 'ಎಲ್ಲಾ',
  adminKycNoSubmissions: 'ಇನ್ನೂ KYC ಸಲ್ಲಿಕೆಗಳಿಲ್ಲ',
  adminOwnerKycTitle: 'ಮಾಲಿಕ KYC ಪರಿಶೀಲನೆ',
  adminOwnerKycNoSubmissions: 'ಇನ್ನೂ ಯಾವುದೇ ಮಾಲಿಕ KYC ಸಲ್ಲಿಕೆಗಳಿಲ್ಲ',
  adminOperatorKycTitle: 'ಆಪರೇಟರ್ KYC ಪರಿಶೀಲನೆ',
  adminOperatorKycNoSubmissions: 'ಇನ್ನೂ ಯಾವುದೇ ಆಪರೇಟರ್ KYC ಸಲ್ಲಿಕೆಗಳಿಲ್ಲ',
  kycRejectedWarning: 'ನಿಮ್ಮ KYC ತಿರಸ್ಕರಿಸಲಾಗಿದೆ. ದಯವಿಟ್ಟು ದಾಖಲೆಗಳನ್ನು ಮತ್ತೆ ಸಲ್ಲಿಸಿ.',
  kycNotSubmittedHint: 'ವಿಶ್ವಾಸಾರ್ಹ ಅನುಭವಕ್ಕಾಗಿ KYC ಪೂರ್ಣಗೊಳಿಸಿ.',
  kycPendingHint: 'ನಿಮ್ಮ KYC ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ.',
  kycGoToTab: 'KYC ಗೆ ಹೋಗಿ',
  adminKycApproveBtn: 'ಅನುಮೋದಿಸಿ',
  adminKycRejectBtn: 'ತಿರಸ್ಕರಿಸಿ',
  adminKycViewDocs: 'ದಾಖಲೆಗಳನ್ನು ನೋಡಿ',
  adminKycRejectReason: 'ತಿರಸ್ಕರಣೆಯ ಕಾರಣ',
  adminKycRereviewBtn: 'ಮತ್ತೆ ಪರಿಶೀಲನೆ',
  kycPan: 'PAN ಕಾರ್ಡ್',
  kycOwnerSubmitSuccess: 'ದಾಖಲೆಗಳನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ — ನಿಮ್ಮ KYC ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ',
  kycLicense: 'ಚಾಲನಾ ಪರವಾನಗಿ',
  kycPoliceVerification: 'ಪೊಲೀಸ್ ಪರಿಶೀಲನೆ',
  kycOperatorSubmitSuccess: 'ದಾಖಲೆಗಳನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ — ನಿಮ್ಮ KYC ಪರಿಶೀಲನೆಯಲ್ಲಿದೆ',
  operatorKycRejectedAssign: 'ಈ ಆಪರೇಟರ್ KYC ತಿರಸ್ಕರಿಸಲಾಗಿದೆ — ಮತ್ತೆ ಅನುಮೋದನೆಯಾಗುವವರೆಗೆ ಅವರನ್ನು ನಿಯೋಜಿಸಲಾಗುವುದಿಲ್ಲ.',
  operatorsColOperator: 'ಆಪರೇಟರ್',
  operatorsColEmail: 'ಇಮೇಲ್',
  operatorsColPhone: 'ಫೋನ್',
  operatorsColDocuments: 'ದಾಖಲೆಗಳು',
  operatorsColStatus: 'ಸ್ಥಿತಿ',
  operatorsDocumentsBtn: 'ದಾಖಲೆಗಳು ({{count}})',
  operatorsNoResults: 'ಆಪರೇಟರ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
  operatorsAllTitle: 'ಎಲ್ಲಾ ಆಪರೇಟರ್‌ಗಳು ({{count}})',
  operatorsKycDialogDesc: 'KYC ದಾಖಲೆಗಳು',
  bookingsCountLabel: '{{count}} ಬುಕಿಂಗ್‌ಗಳು',
  complianceDates: 'ಅನುಪಾಲನೆ ದಿನಾಂಕಗಳು',
  complianceInsurance: 'ವಿಮೆ',
  complianceRcBook: 'RC ಪುಸ್ತಕ',
  compliancePuc: 'PUC',
  complianceNotSet: 'ಹೊಂದಿಸಲಾಗಿಲ್ಲ',
  complianceExpired: 'ಅವಧಿ ಮುಗಿದಿದೆ',
  complianceExpiringSoon: 'ಶೀಘ್ರದಲ್ಲೇ ಅವಧಿ ಮುಗಿಯುತ್ತದೆ',
  complianceExpiringCritical: '7 ದಿನಗಳಲ್ಲಿ ಅವಧಿ',
  complianceValid: 'ಮಾನ್ಯ',
  complianceUpdateBtn: 'ಅನುಪಾಲನೆ ದಿನಾಂಕಗಳನ್ನು ಅಪ್‌ಡೇಟ್ ಮಾಡಿ',
  complianceSaveBtn: 'ಉಳಿಸಿ',
  complianceAlertsTitle: 'ಅನುಪಾಲನೆ ಎಚ್ಚರಿಕೆಗಳು',
  complianceAllCompliant: 'ಎಲ್ಲಾ ಯಂತ್ರಗಳು ಅನುಪಾಲನೆಯಲ್ಲಿವೆ ✅',
  complianceColMachine: 'ಯಂತ್ರ',
  complianceColOwner: 'ಮಾಲೀಕ',
  complianceColInsurance: 'ವಿಮೆ',
  complianceColRcBook: 'RC ಪುಸ್ತಕ',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'ಪ್ರಾರಂಭ ದಿನಾಂಕ',
  complianceEndDate: 'ಮುಕ್ತಾಯ ದಿನಾಂಕ',
  complianceExtractBtn: 'ದಿನಾಂಕಗಳನ್ನು ಸ್ವಯಂ ತುಂಬಲು ದಾಖಲೆ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
  complianceExtractSuccess: 'ದಿನಾಂಕಗಳನ್ನು ಹೊರತೆಗೆಯಲಾಗಿದೆ — ಉಳಿಸುವ ಮೊದಲು ಪರಿಶೀಲಿಸಿ',
  complianceExtractError: 'ದಿನಾಂಕಗಳನ್ನು ಹೊರತೆಗೆಯಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ — ದಯವಿಟ್ಟು ಕೈಯಾರೆ ನಮೂದಿಸಿ',
  complianceExtracting: 'ದಾಖಲೆ ಓದಲಾಗುತ್ತಿದೆ...',
  serviceHistory: 'ಸೇವಾ ಇತಿಹಾಸ',
  serviceLastService: 'ಕೊನೆಯ ಸೇವೆ',
  serviceNoRecords: 'ಇನ್ನೂ ಸೇವಾ ದಾಖಲೆಗಳಿಲ್ಲ',
  serviceNextDue: 'ಮುಂದಿನ ಸೇವೆ ಬಾಕಿ',
  serviceNextHmr: 'ಮುಂದಿನ ಸೇವೆಯಲ್ಲಿ',
  serviceAddLog: 'ಸೇವಾ ಲಾಗ್ ಸೇರಿಸಿ',
  serviceDate: 'ಸೇವಾ ದಿನಾಂಕ',
  serviceType: 'ಸೇವಾ ಪ್ರಕಾರ',
  serviceHmr: 'ಸೇವೆಯ HMR',
  serviceNextDate: 'ಮುಂದಿನ ಸೇವಾ ದಿನಾಂಕ',
  serviceWorkDone: 'ಮಾಡಿದ ಕೆಲಸ',
  serviceNotes: 'ಟಿಪ್ಪಣಿಗಳು',
  serviceTypeRoutine: 'ನಿಯಮಿತ',
  serviceTypeMajor: 'ಪ್ರಮುಖ',
  serviceTypeBreakdown: 'ಕೆಟ್ಟುಹೋಗುವಿಕೆ',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'ಇತರ',
  serviceOverdue: 'ಗಡುವು ಮೀರಿದೆ',
  serviceDueSoon: 'ಶೀಘ್ರದಲ್ಲೇ ಬಾಕಿ',
  fleetAnalytics: 'ಫ್ಲೀಟ್ ವಿಶ್ಲೇಷಣೆ',
  analyticsRevenue: 'ಒಟ್ಟು ಆದಾಯ',
  analyticsBookings: 'ಒಟ್ಟು ಬುಕಿಂಗ್‌ಗಳು',
  analyticsHours: 'ಒಟ್ಟು ಗಂಟೆಗಳು',
  analyticsActiveMachines: 'ಸಕ್ರಿಯ ಯಂತ್ರಗಳು',
  analyticsMonthlyTrend: 'ಮಾಸಿಕ ಆದಾಯ ಪ್ರವೃತ್ತಿ',
  analyticsMachineTable: 'ಯಂತ್ರವಾರು ಆದಾಯ',
  analyticsNoData: 'ಈ ಅವಧಿಯಲ್ಲಿ ಪೂರ್ಣಗೊಂಡ ಬುಕಿಂಗ್‌ಗಳಿಲ್ಲ',
  analyticsLastBooking: 'ಕೊನೆಯ ಬುಕಿಂಗ್',
  analytics3Months: '3 ತಿಂಗಳು',
  analytics6Months: '6 ತಿಂಗಳು',
  analytics12Months: '12 ತಿಂಗಳು',
  adminAnalytics: 'ವಿಶ್ಲೇಷಣೆ',
  adminFleetTitle: 'ಫ್ಲೀಟ್ ವಿಶ್ಲೇಷಣೆ',
  adminFleetPlatformRevenue: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಆದಾಯ',
  adminFleetActiveOwners: 'ಸಕ್ರಿಯ ಮಾಲೀಕರು',
  adminFleetOwnerCol: 'ಮಾಲೀಕ',
  adminFleetMonthlyTrend: 'ಮಾಸಿಕ ಆದಾಯ ಪ್ರವೃತ್ತಿ',
  adminFleetMachineTable: 'ಯಂತ್ರದ ಪ್ರಕಾರ ಆದಾಯ',
  adminFleetNoData: 'ಈ ಅವಧಿಯಲ್ಲಿ ಪೂರ್ಣಗೊಂಡ ಬುಕಿಂಗ್‌ಗಳಿಲ್ಲ',
  adminFinancialIntelligence: 'ಯಂತ್ರ ಹಣಕಾಸು ಬುದ್ಧಿಮತ್ತೆ',
  adminTotalInvested: 'ಒಟ್ಟು ಹೂಡಿಕೆ',
  adminTotalEarned: 'ಒಟ್ಟು ಗಳಿಕೆ',
  adminAvgRecovery: 'ಸರಾಸರಿ ವಸೂಲಿ',
  adminBreakEvenRate: 'ಬ್ರೇಕ್-ಈವನ್ ದರ',
  adminProfitMargin: 'ಲಾಭ ಅಂಚು',
  adminNoFinancialData: 'ಇನ್ನೂ ಹಣಕಾಸು ಡೇಟಾ ಇರುವ ಯಂತ್ರಗಳಿಲ್ಲ',
  adminMachineDetail: 'ಯಂತ್ರ ವಿವರ',
  adminCallOwner: 'ಮಾಲೀಕರಿಗೆ ಕರೆ',
  adminWhatsappOwner: 'WhatsApp ಮಾಲೀಕ',
  adminMarketRates: 'ಮಾರುಕಟ್ಟೆ ದರ ಸಲ್ಲಿಕೆಗಳು',
  adminMarketRateDelete: 'ಅಳಿಸಿ',
  adminMarketRateDeleteConfirm: 'ಈ ಮಾರುಕಟ್ಟೆ ದರ ಸಲ್ಲಿಕೆಯನ್ನು ಅಳಿಸುವುದೇ?',
  adminMarketRateDeleted: 'ಮಾರುಕಟ್ಟೆ ದರ ಅಳಿಸಲಾಗಿದೆ',
  adminMarketRateNoData: 'ಇನ್ನೂ ಮಾರುಕಟ್ಟೆ ದರ ಸಲ್ಲಿಕೆಗಳಿಲ್ಲ',
  marketRateApprove: 'ಅನುಮೋದಿಸಿ',
  marketRateReject: 'ತಿರಸ್ಕರಿಸಿ',
  marketRateApproved: 'ಅನುಮೋದಿತ',
  marketRateRejected: 'ತಿರಸ್ಕೃತ',
  marketRatePending: 'ಬಾಕಿ',
  marketRateReviewed: 'ಮಾರುಕಟ್ಟೆ ದರ ಪರಿಶೀಲಿಸಲಾಗಿದೆ',
  marketRatePendingReview: 'ನಿಮ್ಮ ದರವನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ ಮತ್ತು ಅಡ್ಮಿನ್ ಪರಿಶೀಲನೆಗೆ ಬಾಕಿ ಇದೆ.',
  marketRateEditApprove: 'ಸಂಪಾದಿಸಿ ಮತ್ತು ಅನುಮೋದಿಸಿ',
  marketRateEditMin: 'ಸರಿಪಡಿಸಿದ ಕನಿಷ್ಠ ದರ (₹/ಗಂ)',
  marketRateEditMax: 'ಸರಿಪಡಿಸಿದ ಗರಿಷ್ಠ ದರ (₹/ಗಂ)',
  adminPayrollOverview: 'ಸಂಬಳ ಅವಲೋಕನ',
  adminPayrollTotalOperators: 'ಒಟ್ಟು ಆಪರೇಟರ್‌ಗಳು',
  adminPayrollTotalGross: 'ಒಟ್ಟು ಬಾಕಿ ಮೊತ್ತ',
  adminPayrollTotalNet: 'ಒಟ್ಟು ನಿವ್ವಳ ಬಾಕಿ',
  adminPayrollNoData: 'ಈ ತಿಂಗಳಿಗೆ ಸಂಬಳ ಡೇಟಾ ಇಲ್ಲ',
  subTabSchedule: 'ವೇಳಾಪಟ್ಟಿ',
  subTabHistory: 'ಇತಿಹಾಸ',
  subTabAnalytics: 'ವಿಶ್ಲೇಷಣೆ',
  clientAnalyticsTitle: 'ಬುಕಿಂಗ್ ವಿಶ್ಲೇಷಣೆ',
  clientAnalyticsSpend: 'ಒಟ್ಟು ಖರ್ಚು',
  clientAnalyticsHours: 'ಒಟ್ಟು ಗಂಟೆಗಳು',
  clientAnalyticsBookings: 'ಪೂರ್ಣಗೊಂಡ ಬುಕಿಂಗ್‌ಗಳು',
  clientAnalyticsMachines: 'ಬಳಸಿದ ಯಂತ್ರಗಳು',
  clientAnalyticsAvgSpend: 'ಪ್ರತಿ ಬುಕಿಂಗ್ ಸರಾಸರಿ',
  clientAnalyticsMonthlyTrend: 'ಮಾಸಿಕ ಖರ್ಚು ಪ್ರವೃತ್ತಿ',
  clientAnalyticsTopMachines: 'ಅಗ್ರ ಯಂತ್ರಗಳು',
  clientAnalyticsNoData: 'ಈ ಅವಧಿಯಲ್ಲಿ ಪೂರ್ಣಗೊಂಡ ಬುಕಿಂಗ್‌ಗಳಿಲ್ಲ',
  operatorAnalyticsTitle: 'ಕೆಲಸ ವಿಶ್ಲೇಷಣೆ',
  operatorAnalyticsPresentDays: 'ಹಾಜರಾದ ದಿನಗಳು',
  operatorAnalyticsHalfDays: 'ಅರ್ಧ ದಿನ',
  operatorAnalyticsHmr: 'ಒಟ್ಟು HMR',
  operatorAnalyticsJobs: 'ಪೂರ್ಣಗೊಂಡ ಕೆಲಸಗಳು',
  operatorAnalyticsIssues: 'ವರದಿಯಾಗಿದ ಸಮಸ್ಯೆಗಳು',
  operatorAnalyticsAvgHmr: 'ಸರಾಸರಿ HMR/ದಿನ',
  operatorAnalyticsMonthlyTrend: 'ಮಾಸಿಕ ಕೆಲಸ ಟ್ರೆಂಡ್',
  operatorAnalyticsIssueBreakdown: 'ಪ್ರಕಾರವಾರು ಸಮಸ್ಯೆಗಳು',
  operatorAnalyticsRecentJobs: 'ಇತ್ತೀಚಿನ ಕೆಲಸಗಳು',
  operatorAnalyticsNoData: 'ಈ ಅವಧಿಯಲ್ಲಿ ಕೆಲಸ ದಾಖಲೆಗಳಿಲ್ಲ',
  adminServiceAlertsTitle: 'ಸೇವಾ ಎಚ್ಚರಿಕೆಗಳು',
  adminServiceAllOk: 'ಎಲ್ಲಾ ಯಂತ್ರಗಳ ಸೇವಾ ದಾಖಲೆಗಳು ನವೀಕೃತವಾಗಿವೆ ✅',
  adminServiceNoRecord: 'ದಾಖಲೆಗಳಿಲ್ಲ',
  adminServiceColLastService: 'ಕೊನೆಯ ಸೇವೆ',
  adminServiceColNextDue: 'ಮುಂದಿನ ಗಡುವು',
  adminServiceColServiceStatus: 'ಸೇವಾ ಸ್ಥಿತಿ',
  adminMachinesColMinHrs: 'ಕನಿಷ್ಠ ಗಂ.',
  adminMachinesColRateDay: 'ದರ/ದಿನ',
  adminClientName: 'ಗ್ರಾಹಕರ ಹೆಸರು',
  adminOwnerName: 'ಮಾಲೀಕರ ಹೆಸರು',
  adminPayoutWallet: 'ಪಾವತಿ ವಾಲೆಟ್',
  adminFooterMachines: 'ಯಂತ್ರಗಳು',
  adminFooterClients: 'ಗ್ರಾಹಕರು',
  adminFooterOwners: 'ಮಾಲೀಕರು',
  auditSeverityCritical: 'ಗಂಭೀರ',
  auditSeverityHigh: 'ಹೆಚ್ಚು',
  auditSeverityMedium: 'ಮಧ್ಯಮ',
  auditSeverityNormal: 'ಸಾಮಾನ್ಯ',
  auditCopyEvent: 'ಈವೆಂಟ್ ನಕಲಿಸಿ',
  auditViewDetails: 'ವಿವರಗಳನ್ನು ನೋಡಿ',
  auditHideDetails: 'ವಿವರಗಳನ್ನು ಮರೆಮಾಡಿ',
  auditCopyJson: 'JSON ನಕಲಿಸಿ',
  auditNoLogs: 'ಆಡಿಟ್ ಲಾಗ್‌ಗಳಿಲ್ಲ',
  auditIntroBanner: 'ಲಾಗಿನ್, ನಿರ್ವಾಹಕ ಕ್ರಿಯೆಗಳು ಮತ್ತು ಭದ್ರತಾ ಘಟನೆಗಳು. ಫಿಲ್ಟರ್‌ಗಳು ಲೋಡ್ ಮಾಡಿದ ಫಲಿತಾಂಶಗಳಿಗೆ ಅನ್ವಯಿಸುತ್ತವೆ; ಹಳೆಯ ಸಾಲುಗಳಿಗೆ ಹೆಚ್ಚು ಲೋಡ್ ಮಾಡಿ.',
  auditLoaded: 'ಲೋಡ್ ಮಾಡಲಾಗಿದೆ',
  auditMoreAvailable: 'ಹೆಚ್ಚು ಲಭ್ಯ',
  auditEndOfList: 'ಪಟ್ಟಿ ಅಂತ್ಯ',
  auditFilterActive: 'ಫಿಲ್ಟರ್ ಸಕ್ರಿಯ',
  auditFiltersActive: 'ಫಿಲ್ಟರ್‌ಗಳು ಸಕ್ರಿಯ',
  auditSeverityBreakdown: 'ತೀವ್ರತೆ ವಿಭಜನೆ (ಪ್ರಸ್ತುತ ಪಟ್ಟಿ)',
  auditPressSlash: 'ಕ್ರಿಯೆ ಫಿಲ್ಟರ್‌ಗೆ ಫೋಕಸ್ ಮಾಡಲು / ಒತ್ತಿರಿ',
  auditFilters: 'ಫಿಲ್ಟರ್‌ಗಳು',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'ಎಲ್ಲಾ ಪಾತ್ರಗಳು',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'ಮೆಟಾಡೇಟಾ JSON ಹುಡುಕಿ',
  auditFilterFromPlaceholder: 'ಆರಂಭ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ',
  auditFilterToPlaceholder: 'ಅಂತ್ಯ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'ಸಮಯ ವಲಯ:',
  auditTimezoneSuffix: '(ಸ್ಥಳೀಯ)',
  auditHideCsvOptions: 'CSV ಕಾಲಮ್ ಆಯ್ಕೆಗಳನ್ನು ಮರೆಮಾಡಿ',
  auditShowCsvOptions: 'CSV ಕಾಲಮ್ ಆಯ್ಕೆಗಳನ್ನು ತೋರಿಸಿ',
  auditCsvColCreatedAt: 'ರಚನೆ ಸಮಯ',
  auditCsvColAction: 'ಕ್ರಿಯೆ',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'ಮೆಟಾಡೇಟಾ',
  auditFooterLoaded: 'ಲೋಡ್ ಮಾಡಲಾಗಿದೆ',
  auditFooterLogs: 'ಆಡಿಟ್ ಲಾಗ್‌ಗಳು',
  auditFooterMoreAvailable: '(ಹೆಚ್ಚು ಲಭ್ಯ)',
  auditFooterAllLoaded: '(ಎಲ್ಲಾ ಲೋಡ್ ಮಾಡಲಾಗಿದೆ)',
  auditActor: 'ನಟ',
  auditEntity: 'ಘಟಕ',
  auditEventLog: 'ಈವೆಂಟ್ ಲಾಗ್',
  notificationCenter: 'ಅಧಿಸೂಚನೆಗಳು',
  notifChannelAll: 'ಎಲ್ಲಾ',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ಇಮೇಲ್',
  notifChannelPush: 'ಪುಶ್',
  notifChannelSms: 'SMS',
  notifStatusSent: 'ಕಳುಹಿಸಲಾಗಿದೆ',
  notifStatusFailed: 'ವಿಫಲ',
  notifStatusPending: 'ಬಾಕಿ',
  notifEmpty: 'ಇನ್ನೂ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ',
  notifLoadMore: 'ಇನ್ನಷ್ಟು ಲೋಡ್ ಮಾಡಿ',
  adminNotifLog: 'ಅಧಿಸೂಚನೆ ಲಾಗ್',
  adminNotifColUser: 'ಬಳಕೆದಾರ',
  adminNotifColRole: 'ಪಾತ್ರ',
  adminNotifNoData: 'ಇನ್ನೂ ಅಧಿಸೂಚನೆಗಳು ಲಾಗ್ ಆಗಿಲ್ಲ',
  etaOwnerApproval: 'ಮಾಲಿಕರ ಅನುಮೋದನೆಗಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
  etaWorkInProgress: 'ಅಂದಾಜು ಪೂರ್ಣಗೊಳ್ಳುವಿಕೆ',
  etaPaymentDeadline: 'ಪಾವತಿ ದೃಢೀಕರಣ ಅವಧಿ',
  etaWorkCompleted: 'ಕೆಲಸ ಪೂರ್ಣಗೊಂಡಿತು',
  etaDisputeReview: 'DE ತಂಡ ವಿವಾದವನ್ನು ಪರಿಶೀಲಿಸುತ್ತಿದೆ',
  etaMinutesRemaining: '{n} ನಿಮಿಷಗಳು ಬಾಕಿ',
  etaHoursRemaining: '{n} ಗಂಟೆಗಳು ಬಾಕಿ',
  txRecharge: 'ವಾಲೆಟ್ ರೀಚಾರ್ಜ್',
  txBookingAdvance: 'ಬುಕಿಂಗ್ ಮುಂಗಡ',
  txBookingPayment: 'ಬುಕಿಂಗ್ ಪಾವತಿ',
  txSettlement: 'ಸೆಟಲ್ಮೆಂಟ್',
  txRefund: 'ರಿಫಂಡ್',
  txPenalty: 'ದಂಡ',
  txCommission: 'ಕಮಿಷನ್',
  tacTitle: "ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳು",
  tacPrivacy: "ಗೌಪ್ಯತಾ ನೀತಿ",
  tacRefund: "ಮರುಪಾವತಿ ನೀತಿ",
  tacCancellation: "ರದ್ದತಿ ನೀತಿ",
  tacServiceDelivery: "ಸೇವಾ ವಿತರಣಾ ನೀತಿ",
  tacIntro: "ಬುಕಿಂಗ್ ಮೊದಲು ನಮ್ಮ ನೀತಿಗಳನ್ನು ನೋಡಿ",
  tacBannerTitle: "ನಿಯಮಗಳ ನವೀಕರಣ ಲಭ್ಯ",
  tacBannerOpen: "ನಿಯಮಗಳನ್ನು ತೆರೆಯಿರಿ",
  tacBannerAgree: "ನಾನು ಓದಿ ಒಪ್ಪಿದ್ದೇನೆ",
  tacBannerLater: "ನಂತರ",
  clientPoliciesTitle: "ಕ್ಲೈಂಟ್ ನೀತಿಗಳು",
  machineGroupAvailable: "ಲಭ್ಯ",
  machineGroupBusy: "ಕಾರ್ಯದಲ್ಲಿ",
  dewateringReferral: "ಡಿವಾಟರಿಂಗ್ (ಪಂಪ್) ಸೇವೆ ಬೇಕೇ? MachineOS ಶೀಘ್ರದಲ್ಲೇ ಪಂಪ್ ಗುತ್ತಿಗೆದಾರ ಸೇವೆಗಳನ್ನು ಸೇರಿಸುತ್ತದೆ. ರೆಫರಲ್‌ಗಾಗಿ ಸಪೋರ್ಟ್ ಸಂಪರ್ಕಿಸಿ.",
  noActiveWork: "ಈ ತಿಂಗಳು ಸಕ್ರಿಯ ಕೆಲಸವಿಲ್ಲ",
  accountTab: "ಖಾತೆ",
  recentActivity: "ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ",
  goodMorning: "ಶುಭೋದಯ",
  goodAfternoon: "ಶುಭ ಮಧ್ಯಾಹ್ನ",
  goodEvening: "ಶುಭ ಸಂಜೆ",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
